export const en = {
  nav: {
    dashboard: 'Dashboard',
    vehicles: 'Vehicles',
    leads: 'Leads',
    allLeads: 'All Leads',
    conversations: 'Conversations',
    proposals: 'Proposals',
    marketplace: 'Marketplace',
    newLead: 'New lead',
    newVehicle: 'New vehicle',
    financial: 'Financial',
    management: 'Management',
    sellers: 'Sellers',
    maintenance: 'Maintenance',
    users: 'Users',
    settings: 'Settings',
    settingsGeneral: 'General',
    settingsTheme: 'Theme',
    settingsDealership: 'Dealership',
    settingsPaymentForms: 'Payment Forms',
    settingsRoles: 'Roles & Permissions',
    settingsSub: {
      general: 'General',
      theme: 'Theme',
      dealership: 'Dealership',
      paymentForms: 'Payment methods',
      operation: 'Operations',
      leads: 'Leads',
      vehicleEvaluation: 'Vehicle evaluation',
      operationPipeline: 'Sales pipeline',
      operationPreparation: 'Preparation pipeline',
      leadsSources: 'Media catalog',
      leadsMedia: 'Active media',
      roleAccess: 'Role access',
      billing: 'Subscription & billing',
    },
    salesSection: 'Sales',
    leadsSettingsSub: { kanban: 'Kanban', webhooks: 'Webhooks' },
    bottomNav: { sales: 'Closed deals', pipeline: 'Sales pipeline' },
    products: 'Products/Services',
    more: 'More',
    profile: 'My Profile',
    logout: 'Sign out',
    lightMode: 'Light mode',
    darkMode: 'Dark mode',
    financialSub: {
      overview: 'Overview',
      charges: 'Charges',
      benefits: 'Benefits',
      invoices: 'Invoices',
      payments: 'Payments',
      commissions: 'Commissions',
      commissionRules: 'Commission rules',
      closures: 'Closures',
      fiscalDocuments: 'Tax documents',
    },
    sales: 'Sales',
    salesSub: {
      closedDeals: 'Closed deals',
      acceptedProposals: 'Accepted proposals',
    },
    operation: 'Operations',
    operationSub: {
      postSale: 'Post-sale',
      preparation: 'Preparation',
      deliveries: 'Deliveries',
      postReceipt: 'Post-delivery',
      taskSettings: 'Task settings',
    },
    operationPipelineSettings: 'Pipeline & pre-sale',
    postSales: 'Post-sales',
    postSalesSub: {
      salesPipeline: 'Sales pipeline',
      preparationPipeline: 'Preparation pipeline',
      deliveries: 'Deliveries',
      configureSalesPipeline: 'Settings',
      postReceipt: 'Post-delivery',
      dashboard: 'Dashboard',
    },
    leadsSub: {
      all: 'All Leads',
      report: 'Report',
      conversations: 'Conversations',
      distribution: 'Distribution',
      settings: 'Settings',
    },
    marketplaceSub: {
      integrations: 'Integrations',
      publications: 'Publications',
      history: 'History',
    },
  },

  roleAccess: {
    title: 'Role access',
    subtitle: 'Define which menus and features each profile can access.',
    loadError: 'Failed to load permissions.',
    saveError: 'Failed to save permissions.',
    saveSuccess: 'Permissions updated successfully.',
    save: 'Save changes',
    saving: 'Saving...',
    ownerOnly: 'Only the owner can manage role access.',
    ownerFullAccess: 'The owner has full access and cannot be restricted.',
    sectionRoot: 'Main menu',
    roles: {
      owner: 'Owner',
      manager: 'Manager',
      salesperson: 'Salesperson',
      financial: 'Financial',
      mechanic: 'Mechanic',
      viewer: 'Viewer',
    },
  },

  myProfile: {
    title: 'My profile',
    subtitle: 'Update your data, photo, and preferences',
    tabs: {
      data: 'Details',
      photo: 'Photo',
      security: 'Security',
    },
    name: 'Full name',
    namePlaceholder: 'Your full name',
    email: 'E-mail',
    emailPlaceholder: 'your@email.com',
    phone: 'Phone',
    phoneCountryCode: 'Country code',
    phoneArea: 'Area code',
    phoneNumber: 'Number',
    phonePlaceholder: '999999999',
    phoneHelp: 'Use the number your team uses day to day.',
    phoneRequired: 'Phone is required',
    cancel: 'Cancel',
    save: 'Save changes',
    saving: 'Saving...',
    success: 'Profile updated successfully!',
    nameRequired: 'Name is required',
    heroRole: 'Role',
    heroStatus: 'Status',
    heroLastLogin: 'Last login',
    heroCreatedAt: 'Account created',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    contextBackoffice: 'Backoffice',
    contextDealership: 'Dealership',
    roles: {
      owner: 'Owner',
      manager: 'Manager',
      salesperson: 'Salesperson',
      financial: 'Finance',
      mechanic: 'Mechanic',
      viewer: 'Viewer',
    },
    photoTitle: 'Profile photo',
    photoDescription: 'Choose a square image so your profile looks great in the app header.',
    photoUpload: 'Choose photo',
    photoRemove: 'Remove photo',
    photoHint: 'The image is saved in this browser and appears across the app.',
    securityTitle: 'Security and access',
    securityDescription: 'Summary of your account and current permissions.',
    securityNeverLogin: 'No login history yet',
    securityActive: 'Account active',
    securityInactive: 'Account inactive',
  },


  userRegistration: {
    titleCreate: 'New User',
    titleEdit: 'Edit User',
    subtitleCreate: 'Register a new user at your dealership',
    subtitleEdit: 'Edit the user information',
    back: 'Back',
    cardTitle: 'User Information',
    nameLabel: 'Full name',
    namePlaceholder: 'Enter the full name',
    emailLabel: 'Email',
    emailPlaceholder: 'user@company.com',
    countryCodeLabel: 'Country code',
    countryCodePlaceholder: '+1',
    areaLabel: 'Area code',
    areaPlaceholder: '11',
    phoneLabel: 'Phone',
    phonePlaceholder: '99999-9999',
    userStatusLabel: 'User status',
    active: 'Active',
    inactive: 'Inactive',
    roleLabel: 'Role *',
    loadingRoles: 'Loading roles...',
    selectedRolePrefix: 'Selected role:',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Minimum 6 characters',
    confirmPasswordLabel: 'Confirm password',
    confirmPasswordPlaceholder: 'Confirm the password',
    roleInfoPrefix: 'Selected role:',
    cancel: 'Cancel',
    submitCreate: 'Create User',
    submitEdit: 'Save Changes',
    successCreate: 'User created successfully!',
    createError: 'Error creating user. Please try again.',
    validation: {
      nameRequired: 'Name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email',
      passwordRequired: 'Password is required',
      passwordMin: 'Password must be at least 6 characters',
      confirmPasswordRequired: 'Password confirmation is required',
      passwordMismatch: 'Passwords do not match',
      roleRequired: 'Role is required',
      areaRequired: 'Area code is required',
      phoneRequired: 'Phone is required',
    },
  },

  userProfile: {
    title: 'User profile',
    subtitle: 'View and edit user information',
    backToList: 'Back to list',
    back: 'Back',
    edit: 'Edit',
    notFoundTitle: 'User not found',
    notFoundDescription: 'The requested user could not be found.',
    basicInfoTitle: 'Basic information',
    detailsTitle: 'Detailed information',
    editInfoTitle: 'Edit information',
    namePlaceholder: 'John Doe',
    emailPlaceholder: 'john@example.com',
    newPasswordLabel: 'New password (optional)',
    newPasswordPlaceholder: 'Leave blank to keep the current password',
    confirmNewPasswordLabel: 'Confirm new password',
    confirmNewPasswordPlaceholder: 'Confirm the new password',
    phonesLabel: 'Phones',
    noPhones: 'No phone numbers registered',
    noPhonesAdded: 'No phone numbers added',
    addPhone: 'Add phone',
    addPhoneToStart: 'Click "Add phone" to get started',
    phoneItemLabel: 'Phone {{number}}',
    primaryBadge: 'Primary',
    makePrimary: 'Make primary',
    countryCodeLabel: 'Country code',
    countryCodePlaceholder: '+1',
    areaLabel: 'Area code',
    areaPlaceholder: '11',
    phoneLabel: 'Phone',
    phonePlaceholder: '99999-9999',
    roleLabel: 'Role',
    selectProfile: 'Select a profile',
    userStatusLabel: 'User status',
    createdAtLabel: 'Created at',
    lastLoginLabel: 'Last login',
    profileDescriptionTitle: 'Profile description',
    successUpdate: 'Profile updated successfully!',
    validation: {
      phonesRequired: 'At least one phone number is required',
    },
  },

  dashboard: {
    title: 'Dashboard',
    subtitle: 'Overview of your dealership',
    error: {
      load: 'Could not load dashboard data',
    },
    actions: {
      refresh: 'Refresh',
      refreshing: 'Refreshing...',
      tryAgain: 'Try again',
    },
    stats: {
      vehicles: 'Vehicles',
      leads: 'Leads',
      revenue: 'Revenue',
      conversion: 'Conversion',
    },
    charts: {
      salesAndLeads: 'Sales and Leads per Month',
      sales: 'Sales',
      leadStatus: 'Lead Status',
      noData: 'No data available',
    },
    recentLeads: {
      title: 'Recent Leads',
      empty: 'No recent leads',
    },
    analytics: {
      monthlyDescription: 'Monthly comparison of demand generation and closed sales.',
      statusDescription: 'Current lead distribution by commercial status.',
      recentLeadsDescription: 'Latest opportunities received by the sales team.',
      units: 'Units',
      stockAging: {
        title: 'Stock Aging',
        description: 'Lot time by range',
        ranges: {
          upTo15: '0-15 days',
          from16To30: '16-30 days',
          from31To60: '31-60 days',
          from61To90: '61-90 days',
          over90: '+90 days',
        },
      },
      leadSla: {
        title: 'Lead SLA',
        target: 'WhatsApp response target',
        firstResponse: '1st response',
        qualification: 'Qualification',
        followUp: 'Follow-up',
      },
      salesFunnel: {
        title: 'Full Sales Funnel',
        description: 'Conversion by stage',
        leads: 'Leads',
        qualified: 'Qualified',
        proposals: 'Proposals',
        negotiation: 'Negotiation',
        closed: 'Sales',
      },
      leaderboard: {
        title: 'Seller Leaderboard',
      },
      preparation: {
        title: 'Preparation Bottlenecks',
        defaultStage: 'Preparation',
        documentation: 'Documentation',
        service: 'Service',
        detailing: 'Detailing',
      },
    },
  },

  // Common actions
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    add: 'Add',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    close: 'Close',
    view: 'View',
    duplicate: 'Duplicate',
    loading: 'Loading...',
    submit: 'Submit',
    update: 'Update',
  },

  salesPipeline: {
    title: 'Sales pipeline',
    subtitle:
      'Stage position is derived from the sale and proposal status. Select a sale to view the pipeline.',
    selectSale: 'Sale',
    selectPlaceholder: 'Select a sale',
    loadSaleError: 'Could not load sale details.',
    loadSalesError: 'Could not load sales list.',
    currentStageTitle: 'Current position',
    cancelledSale: 'This sale is cancelled. The illustrative pipeline does not apply.',
    stagesExplainTitle: 'What each stage means',
    stages: {
      first_contact: 'First contact',
      qualification: 'Qualification',
      vehicle_interest: 'Vehicle interest',
      visit_test_drive: 'Visit / Test drive',
      proposal_sent: 'Proposal sent',
      negotiation: 'Negotiation',
      proposal_approved: 'Proposal approved',
      payment: 'Payment',
      sale_confirmed: 'Sale confirmed',
      preparation: 'Preparation',
      delivery: 'Delivery',
    },
    stageHelp: {
      first_contact:
        'Initial capture of customer interest: lead source, contact details, and handoff to sales.',
      qualification:
        'Profile, need, budget, and fit are assessed to steer the conversation toward the right vehicle.',
      vehicle_interest:
        'Customer focuses on specific models; price, trim, equipment, and stock availability are aligned.',
      visit_test_drive:
        'Showroom visit or test drive so the customer experiences the vehicle and confirms interest.',
      proposal_sent:
        'Formal proposal with pricing, payment terms, and deadlines sent for customer review.',
      negotiation:
        'Refining price, down payment, trade-in, accessories, or timelines until offer and expectation meet.',
      proposal_approved:
        'Customer accepts the proposal; documentation checks begin before payment completion.',
      payment:
        'Receiving funds as agreed (installments, financing, transfers) until the sale amount is settled.',
      sale_confirmed:
        'Sale is recognized operationally after payment or contract; vehicle preparation follows.',
      preparation:
        'Post-sale checklist: paperwork, service, detailing, and accessories to make the vehicle ready.',
      delivery:
        'Handover to the customer with usage guidance and formal closure of this sale cycle.',
    },
  },

  financialSales: {
    title: 'Sales',
    tabs: {
      list: 'List',
      pipeline: 'Sales pipeline',
    },
    filters: 'Filters',
    status: 'Status',
    startDate: 'Start date',
    endDate: 'End date',
    startDatePlaceholder: 'Select start date',
    endDatePlaceholder: 'Select end date',
    clearFilters: 'Clear filters',
    loadError: 'Failed to load sales',
    empty: 'No sales found',
    statusAll: 'All',
    statusLabels: {
      open: 'Open',
      waiting_payment: 'Awaiting payment',
      paid: 'Paid',
      in_preparation: 'In preparation',
      ready_for_delivery: 'Ready for delivery',
      delivered: 'Delivered',
      pending: 'Pending',
      confirmed: 'Confirmed',
      cancelled: 'Cancelled',
    },
    viewProposal: 'View proposal',
    proposalCardTitle: 'Proposal',
    saleItemsTitle: 'Additional sale items',
    saleItemDescription: 'Description',
    saleItemQty: 'Qty',
    saleItemUnit: 'Unit price',
    saleItemTotal: 'Total',
    paymentFormLabel: 'Payment method',
    paymentFormPlaceholder: 'Select',
    paymentOptionLabel: 'Method option',
    paymentOptionPlaceholder: 'Optional',
    paymentOptionNone: 'None',
    paymentFormColumn: 'Payment method',
    saleChargesTitle: 'Financial charges',
    saleChargesEmpty: 'No charges recorded for this sale.',
    saleChargeNameColumn: 'Charge',
    saleChargeValueColumn: 'Amount',
    saleBenefitsTitle: 'Sale benefits',
    saleBenefitsEmpty: 'No benefits recorded for this sale.',
    saleBenefitNameColumn: 'Benefit',
    saleBenefitValueColumn: 'Applied value',
    customerCard: {
      title: 'Customer',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      notes: 'Notes',
    },
    vehicleCard: {
      title: 'Vehicle',
      plate: 'Plate',
    },
    salespersonCard: {
      title: 'Salesperson',
    },
    leadSnapshot: {
      title: 'Lead history (snapshot)',
      capturedAt: 'Captured at',
      interestsTitle: 'Vehicle interests',
      legacyVehicleTitle: 'Legacy linked vehicle',
      preferencesTitle: 'Search preferences',
      proposalsTitle: 'Lead proposals',
      contactsTitle: 'Lead contacts',
      emptySnapshot: 'Lead snapshot unavailable. Create or refresh a proposal to populate this data.',
      proposalColumns: {
        status: 'Status',
        value: 'Value',
        final: 'Final',
        vehicle: 'Vehicle',
        date: 'Date',
      },
      proposalStatus: {
        open: 'Open',
        in_negotiation: 'In negotiation',
        approved: 'Approved',
        rejected: 'Rejected',
        expired: 'Expired',
      },
    },
    leadSnapshotValidation: {
      title: 'Review',
      vehicleNotInInterests:
        'This sale vehicle was not in the interests list captured from the lead.',
      documentMismatch: 'Customer document differs from the document stored in the lead snapshot.',
      proposalVehicleMismatch:
        'The linked proposal vehicle differs from the current sale vehicle.',
    },
    commissions: {
      edit: 'Edit amounts',
      base: 'Base',
      percent: 'Percentage (%)',
      calculatedValue: 'Agreed / paid amount',
      fixedValueColumn: 'Fixed amount',
      fixedValueLabel: 'Fixed amount',
      mixedBreakdown: 'Amount {{fixed}} + {{percent}} (total at {{totalPercent}})',
      originalColumn: 'Original (rule)',
      agreedColumn: 'Agreed',
      differenceColumn: 'Difference',
      saveSuccess: 'Commission updated',
      saveLocalSuccess: 'Changes applied on screen. They are saved when marked as paid.',
      saveCommissionEditSuccess:
        'Commission values updated on screen (finalized when marked as paid). Bonuses saved to the server.',
      saveError: 'Could not update commission',
      onlyPending: 'Only pending commissions can be edited',
      invalidValues: 'Invalid values. Use positive numbers.',
      mandatoryReadonly:
        'This commission is required by configuration and cannot be edited.',
      mandatoryBadge: 'Required',
      remove: 'Remove',
      confirmStepCta: 'Confirm commissions',
      confirmNoCommissionsCta: 'Commissions complete',
      stepConfirmHint:
        'Confirm after review (or when there are no lines) to unlock the next post-sale step.',
      stepConfirmedHint: 'Commissions confirmed on {{date}}.',
      confirmStepSuccess: 'Commission step confirmed.',
      confirmStepError: 'Could not confirm the commission step.',
      deleteDialogTitle: 'Remove commission',
      deleteDialogDescription:
        'This line will be removed from the sale. Any prior commission-step confirmation will be cleared.',
      deleteSuccess: 'Commission removed.',
      deleteError: 'Could not remove the commission.',
      summaryVehicleValue: 'Vehicle value',
      summaryCommissionsTotal: 'Total commissions',
      summaryVehicleMinusCommissions: 'Vehicle value - commissions',
      editAfterConfirm: 'Edit commissions',
      lockedAfterPreparation: 'Commissions are locked after sending to preparation.',
      payRequiresCommissionConfirmation:
        'Confirm commissions for this sale before marking them as paid.',
      paymentRuleAfterInvoice: 'After invoicing',
      paymentRuleAfterPayment: 'After customer payment',
      bonusColumn: 'Bonus',
      bonusValuesColumn: 'Bonus values',
      totalWithBonusesColumn: 'Total (incl. bonus)',
      bonusSectionTitle: 'Bonuses for this commission',
      bonusAmountLabel: 'Amount',
      bonusLabelPlaceholder: 'Bonus description',
      bonusAdd: 'Add bonus',
      bonusRemove: 'Remove',
      bonusInvalid: 'Enter a description and a valid bonus amount.',
      bonusAddSuccess: 'Bonus added.',
      bonusRemoveSuccess: 'Bonus removed.',
      bonusSaveError: 'Could not save the bonus.',
    },
    commissionSettings: {
      title: 'Commissions on sales',
      applyStoreRules: 'Include store and manager rules on every sale',
      applyStoreHint:
        'When enabled, rules with “Applies to” Store or Manager are included in automatic commission generation for each sale.',
      saveSuccess: 'Settings saved.',
      saveError: 'Could not save settings.',
    },
    fiscalExport: {
      title: 'Fiscal export (accounting)',
      description:
        'Dealership CNPJ, fiscal data and address of the vehicle branch, customer and vehicle for NF-e (no XML). Fix issues and download PDF or JSON.',
      missingTitle: 'Missing fields',
      readyHint: 'Minimum data is complete for export.',
      downloadJson: 'Download JSON',
      downloadPdf: 'Download PDF',
      editDealership: 'Branches & branch fiscal',
      editVehicle: 'Edit vehicle',
      editCustomer: 'Edit customer',
      loadError: 'Could not load fiscal export.',
      pdfLoadError: 'Could not generate fiscal PDF.',
      missing: {
        issuerCnpj: 'Issuer CNPJ',
        issuerLegalName: 'Issuer legal / trade name',
        customerAddressStreet: 'Customer street',
        customerAddressNumber: 'Customer number',
        customerAddressCity: 'Customer city',
        customerAddressState: 'Customer state',
        customerAddressZip: 'Customer ZIP',
        branchLinkVehicle: 'Branch: link the sale vehicle to a branch with a full address',
        branchStateRegistration: 'Branch IE (branch settings)',
        branchTaxRegime: 'Branch tax regime (branch settings)',
        branchName: 'Branch name',
        branchNeighborhood: 'Branch neighborhood',
        branchAddressStreet: 'Branch street',
        branchAddressNumber: 'Branch number',
        branchAddressCity: 'Branch city',
        branchAddressState: 'Branch state',
        branchAddressZip: 'Branch ZIP code',
        customerDocument: 'Customer CPF/CNPJ',
        customerCpf: 'Customer CPF (11 digits)',
        customerCnpj: 'Customer CNPJ (14 digits)',
        customerName: 'Customer name',
        customerEmail: 'Customer email',
        customerPhone: 'Customer phone',
        vehiclePlate: 'License plate',
        vehicleChassis: 'VIN / chassis',
        vehicleRenavam: 'RENAVAM',
        vehicleFuel: 'Fuel',
        vehicleColor: 'Color',
        itemNcm: 'NCM (vehicle branch default, dealership default, or FISCAL_DEFAULT_NCM)',
        itemCfop: 'CFOP (vehicle branch default, dealership default, or FISCAL_DEFAULT_CFOP)',
      },
      customerEdit: {
        title: 'Edit customer',
        save: 'Save',
        back: 'Back',
        saveSuccess: 'Customer updated.',
        saveError: 'Could not save customer.',
        loadError: 'Could not load customer.',
      },
    },
    commissionRuleForm: {
      stepBasic: 'Basic configuration',
      stepAdvanced: 'Advanced rules',
      stepValidity: 'Validity period',
      activeRuleLabel: 'Active rule',
      nameRequired: 'Enter the rule name. This field is required.',
      ruleBonusTitle: 'Rule bonuses',
      ruleBonusHint:
        'Default amounts copied to each commission created from this rule. On the sale, they can be adjusted under Edit values.',
      salespersonLabel: 'Rule salesperson (optional)',
      salespersonAll: 'All salespeople',
      salespersonHint: 'Only applies when the sale salesperson matches.',
      listSalespersonColumn: 'Salesperson',
      sharedAmongLabel: 'Shared rule for all salespeople',
      sharedAmongHint:
        'When enabled, this salesperson rule applies to any sale salesperson (no specific salesperson required).',
      sharedBadge: 'Shared',
      paymentFormHint:
        'If you pick a payment form, the rule only applies when the sale includes that form (in the proposal installments).',
      tierFixBeforeContinue:
        'Fix the value tiers: invalid or overlapping ranges. You cannot continue or save until this is corrected.',
      tierInvalidRange: 'The maximum must be greater than the minimum.',
      tierOverlap: 'This tier overlaps another. Adjust the limits so they do not cross.',
      tierEmpty: 'Add at least one value tier.',
      vigenceStatusNone: 'No validity period',
      vigenceStatusFuture: 'Upcoming',
      vigenceStatusExpired: 'Expired',
      vigenceStatusActive: 'Active',
      nameField: 'Name',
      namePlaceholder: 'e.g. Default salesperson commission',
      descriptionField: 'Description',
      descriptionPlaceholder: 'Describe what this rule is for...',
      commissionKindLabel: 'Commission type',
      calculationModeLabel: 'Calculation mode',
      percentSingle: 'Fixed percentage',
      tierMode: 'Value tiers',
      percentValueLabel: 'Percentage (%)',
      tiersTitle: 'Value tiers',
      addTierRow: 'Add tier',
      tierMin: 'Minimum value',
      tierMax: 'Maximum value (optional)',
      tierPercent: 'Percentage (%)',
      tierHintEmpty: 'Click "Add tier" to create commission tiers.',
      fixedBlockLabel: 'Fixed amount',
      calculationBase: 'Calculation base',
      calcBaseVehicle: 'Vehicle value',
      calcBaseProfit: 'Profit',
      calcBaseFinanced: 'Financed amount',
      applicableToField: 'Applies to',
      paymentRuleField: 'Payment rule',
      mixedOption: 'Mixed (% + fixed)',
      vehicleTypeField: 'Vehicle type',
      vehicleAll: 'Both',
      vehicleNew: 'New',
      vehicleUsed: 'Used',
      paymentFormField: 'Payment method',
      paymentPlaceholder: 'Select a payment method (optional)',
      paymentNone: 'None',
      maxCommissionField: 'Maximum commission cap',
      maxCommissionPlaceholder: 'No cap',
      maxCommissionHelp: 'Leave blank for no cap.',
      startAt: 'Start date',
      endAt: 'End date',
      validityHint: 'Leave dates blank for an open-ended rule.',
      startPlaceholder: 'Select start date and time',
      endPlaceholder: 'Select end date and time',
      createRuleCta: 'Create rule',
      updateRuleCta: 'Update rule',
    },
    commissionRulesPage: {
      listSubtitle: 'Manage percentages, tiers, and validity for store commissions.',
      registeredRules: 'Registered rules ({{count}})',
      emptyList: 'No commission rules found.',
      loadError: 'Could not load commission rules.',
      duplicateSuccess: 'Commission rule duplicated successfully.',
      duplicateError: 'Could not duplicate the rule.',
      deleteSuccess: 'Rule deleted successfully.',
      deleteError: 'Could not delete the rule.',
      deleteTitle: 'Confirm deletion',
      deleteDescription:
        'Are you sure you want to delete the rule "{{name}}"? This cannot be undone.',
      duplicateTitle: 'Duplicate rule',
      duplicateDescription:
        'Duplicate the rule "{{name}}"? The new rule will be created as inactive.',
      formTitleNew: 'New commission rule',
      formTitleEdit: 'Edit commission rule',
      formSubtitleNew: 'Fill in the new commission rule details.',
      formSubtitleEdit: 'Editing: {{name}}',
      filtersTitle: 'Filters',
      filterStatus: 'Status',
      filterType: 'Type',
      filterApplicable: 'Applies to',
      filterVigence: 'Validity',
      allMasc: 'All',
      allFem: 'All',
      activeRules: 'Active',
      inactiveRules: 'Inactive',
      vigenceCurrent: 'Current',
      vigencePast: 'Expired',
      colName: 'Name',
      colType: 'Type',
      colValue: 'Value / %',
      colApplicable: 'Applies to',
      colStatus: 'Status',
      colVigence: 'Validity',
      colActions: 'Actions',
      statusOn: 'Active',
      statusOff: 'Inactive',
      bonusDash: '—',
      saveRuleError: 'Could not save the commission rule.',
      createSuccess: 'Commission rule created successfully.',
      updateSuccess: 'Commission rule updated successfully.',
    },
    commissionRuleEvaluation: {
      sectionTitle: 'Active rules for this sale',
      notApplicable: 'Rule not applicable',
      enabledOnSale: 'Enabled on this sale',
      onSaleColumn: 'On sale',
      ruleColumn: 'Rule',
      statusColumn: 'Status',
      applicableToColumn: 'Applies to',
      availableToAddHint: 'Available to add manually.',
      reasons: {
        inactive: 'Rule is inactive.',
        vehicle_type: 'The sale vehicle type does not match the rule.',
        payment_form: 'The sale payment method does not match the rule.',
        vigence_before_start: 'The rule validity period has not started yet.',
        vigence_after_end: 'The rule validity period has ended.',
        salesperson_scope: 'The sale salesperson does not match the rule salesperson.',
      },
      info: {
        manager_dealership_auto_disabled:
          'Not included in automatic generation while “include store and manager rules” is off; can still be added manually.',
      },
      applicableTo: {
        salesperson: 'Salesperson',
        manager: 'Manager',
        dealership: 'Store',
      },
      mandatoryWillApplyHint:
        'Mandatory rule: included in automatic generation when criteria are met.',
      noRulesInSelect: 'No rules available',
    },
    preparationCostsTitle: 'Preparation costs',
    preparationCostsAdd: 'Add cost',
    preparationCostsDescription: 'Description',
    preparationCostsDescriptionPlaceholder: 'Cost description',
    preparationCostsAmount: 'Amount',
    preparationCostsType: 'Type',
    preparationCostsTypePlaceholder: 'Select',
    preparationCostsEmpty: 'No preparation costs recorded',
    costTypes: {
      mechanical: 'Mechanical',
      bodywork: 'Bodywork',
      documentation: 'Documentation',
      cleaning: 'Cleaning',
      accessories: 'Accessories',
      other: 'Other',
    },
    paymentsTab: {
      summaryTitle: 'Payment summary',
      finalValue: 'Sale final amount',
      totalConfirmed: 'Received (confirmed)',
      totalPending: 'Planned (pending)',
      remaining: 'Outstanding',
      fullyPaidBadge: 'Fully received',
      proposalReference: 'Payment terms (proposal)',
      installmentsCount: '{{count}} installment(s)',
      dueDate: 'Due date',
      amount: 'Amount',
      status: 'Status',
      tradeTitle: 'Trade-in vehicles (proposal)',
      tradeMismatchHint:
        'If the appraised value differs from the proposal, cancel this sale and create a new proposal with the correct amounts.',
      vehicle: 'Vehicle',
      offeredValue: 'Value on proposal',
      cancelSaleCta: 'Cancel sale and renegotiate',
      cancelSaleHint: 'To fix amounts after a trade-in or deal mismatch, cancel the sale and create a new proposal.',
      cancelSaleTitle: 'Cancel sale',
      cancelSaleDescription:
        'The sale will be marked cancelled. Create a new proposal for the customer with updated amounts.',
      cancelSaleConfirm: 'Cancel sale',
      cancelSaleSuccess: 'Sale cancelled',
      cancelSaleError: 'Could not cancel the sale',
      chargesTitle: 'Charges on sale',
      chargeValue: 'Amount',
      discountPct: 'Discount %',
      invoicePayments: 'Invoice payments',
      invoiceNumber: 'Invoice #{{n}}',
      date: 'Date',
      method: 'Method',
      saleReceipts: 'Sale receipts',
      addReceipt: 'Add receipt',
      paidDate: 'Payment date',
      registerAsPending: 'Register as pending (not received yet)',
      noReceipts: 'No receipts recorded',
      statusPending: 'Pending',
      statusConfirmed: 'Confirmed',
      statusCancelled: 'Cancelled',
      splitTitle: 'Split receipt',
      splitDescription: 'Enter two amounts that add up to the original line. New lines will be pending.',
      splitPart1: 'Part 1 amount',
      splitPart2: 'Part 2 amount',
      splitConfirm: 'Split',
      deleteTitle: 'Delete receipt',
      deleteDescription: 'Delete this pending line? This cannot be undone.',
      deleteSuccess: 'Receipt deleted',
      deleteError: 'Could not delete',
      splitSuccess: 'Receipt split',
      splitError: 'Could not split',
      savePaymentSuccess: 'Receipt updated',
      savePaymentError: 'Could not update',
      addPaymentSuccess: 'Receipt recorded',
      addPaymentError: 'Could not record',
      invalidAmount: 'Enter a valid numeric amount',
      invalidDiscount: 'Discount must be between 0 and 100%',
      chargeSaveSuccess: 'Charge updated',
      chargeSaveError: 'Could not update charge',
    },
    saleDetailDates: {
      performedOn: 'Sale date',
      registeredOn: 'Registered on',
      saleDateField: 'Sale date',
      registeredAtField: 'Registration date',
    },
    saleDetailsTabs: {
      details: 'Details',
      administrative: 'Administrative',
      preparation: 'Preparation',
      operation: 'Pipeline',
      timeline: 'Timeline',
      financial: 'Financial',
      commissions: 'Commissions',
      payments: 'Payments',
      documents: 'Documents',
    },
    saleOnboarding: {
      title: 'Path to preparation pipeline',
      subtitle:
        'Follow the order: the next step unlocks only after all previous steps are complete.',
      loading: 'Loading progress…',
      syncing: 'Syncing with server…',
      lockedStepHint: 'Complete the previous steps first.',
      tabLockedToast: 'Complete the previous steps to open this tab.',
      steps: {
        payment: 'Payment',
        documentation: 'Documentation',
        commissions: 'Commissions',
        invoicing: 'Invoicing',
        pipeline: 'Ready for preparation',
      },
      sendCta: 'Send to preparation pipeline',
      sending: 'Sending…',
      sendSuccess: 'Sale sent to preparation.',
      sendError: 'Could not send to the pipeline.',
      hintCompleteRequirements:
        'Complete payment, documentation, mandatory commissions, invoicing (authorized fiscal doc or invoice), and post-sale checklist.',
      inPipeline: 'This sale is already in preparation or a later stage.',
      requirementsTitle: 'Documentation and contract requirements',
      customerDocsSection: 'Required documents',
      contractsSection: 'Required contracts',
      attachCustomer: 'Link: customer profile',
      attachSale: 'Link: sale documents',
      selectDocument: 'Select a file',
      linkDocument: 'Link',
      linking: 'Linking…',
      docLinked: 'Document linked.',
      docLinkError: 'Could not link the document.',
      pickDocumentFirst: 'Select a document from the list.',
      uploadFirstHint: 'Upload the file below, then link it here.',
      uploadCustomerTitle: 'Upload customer document',
      openTemplate: 'Open reference template',
      signDate: 'Signature date',
      signedPdfOptional: 'Signed PDF (optional)',
      optional: 'Optional',
      none: 'None',
      saving: 'Saving…',
      confirmSignature: 'Record signature',
      contractSigned: 'Signature recorded.',
      contractSignError: 'Could not record the signature.',
      pickSignDate: 'Enter the signature date.',
    },
    saleDocumentation: {
      tabSaleDocs: 'Sale documents',
      tabVehicle: 'Vehicle documents',
      tabContracts: 'Signed contracts',
      saleUploadTitle: 'Upload documents',
      saleListTitle: 'Sale documents',
      documentationAccordionChecklist: 'Documentation checklist',
      documentationAccordionUploadsHint:
        'Each section lists files already uploaded for this sale and lets you add more.',
      slotFileCount: '{{count}} file(s)',
      slotUploadedListLabel: 'Files for this sale (this type)',
      slotNoFilesYet: 'No files of this type yet.',
      checklistTitle: 'Documentation checklist',
      vehicleMandatoryTitle: 'Sale documentation uploads',
      vehicleListTitle: 'Vehicle registry documents',
      vehicleRegistryHint:
        'Only documents already saved on the vehicle record. For this sale’s paperwork, use the Sale documents tab.',
      vehicleRegistryEmpty: 'No documents on the vehicle record.',
      uploadSlot: 'Upload file',
      readOnlyHint: 'You do not have permission to edit.',
      noVehicle: 'This sale has no linked vehicle.',
      noContracts: 'No contract templates configured for this dealership.',
      uploadSaleContractTitle: 'Signed contract (file)',
      uploadSignedContract: 'Upload signed contract PDF',
      signedBadge: 'Signed',
      pendingBadge: 'Pending',
      updateSignature: 'Update signature',
      invoiceSyncedHint: 'Completed automatically when fiscal NF-e is authorized or invoice is issued.',
      checklistSaved: 'Checklist updated.',
      checklistCleared: 'Item cleared.',
      checklistError: 'Could not update the checklist.',
      deleteError: 'Could not remove the document.',
      checklistUploadRequiredHint:
        'You can only tick an item after the matching file has been uploaded. The invoice line syncs automatically.',
      checklistBadgeRequired: 'Required at this step',
      checklistBadgeRecommended: 'Recommended',
      checklistBadgeSend: 'Required to send to preparation',
      checklistAtpvHint:
        'ATPV-e may suffice at the DMV; for legal safety keep proof with two signatures (receipt, TED/PIX, purchase agreement, etc.).',
      pjCorporateBanner:
        'Legal entity: upload CNPJ card, articles of incorporation, and authorized signatory ID in the cards above (required to proceed).',
      slotOptionalHint: 'optional at this step',
      checklistKeys: {
        buyer_id: 'Buyer ID (ID card / CPF or CNPJ)',
        address_proof: 'Proof of address',
        atpv_signed: 'ATPV / legal proof (two signatures)',
        invoice_issued: 'Invoice issued',
        inspection_done: 'Inspection completed',
        transfer_fee_paid: 'Transfer fee paid',
        sent_to_dispatcher: 'Transfer sent to dispatcher',
      },
      slotRgCpf: 'ID and CPF',
      slotCnpj: 'CNPJ',
      slotArticles: 'Articles of incorporation',
      slotResponsible: 'Authorized representative ID',
      slotAddressProof: 'Proof of address',
      slotAtpv: 'Signed ATPV',
      slotInspection: 'Inspection report',
      slotPaymentFees: 'Payment and fee receipts',
      slotDebts: 'Debt clearance (IPVA, fines)',
      slotTransferFee: 'Transfer fee receipt',
      slotDispatcherProof: 'Proof sent to dispatcher',
      documentUpload: {
        defaultLabel: 'Document upload',
        selectFile: 'Choose file',
        changeFile: 'Choose another',
        cancelSelection: 'Cancel',
        confirmUpload: 'Upload document',
        uploading: 'Uploading…',
        previewPdf: 'PDF preview',
        previewOther: 'No inline preview for this type. Check the file name and upload.',
        tempFailed: 'Temporary upload failed',
        saleIdRequired: 'saleId is required to upload for this entity',
        invalidTempResponse: 'Invalid upload response',
      },
    },
    saleLifecycle: {
      phases: {
        payment: 'Payment',
        documentation: 'Documentation',
        commissions: 'Commissions',
        invoicing: 'Invoicing',
        ready_for_preparation: 'Ready for preparation',
        quality_control: 'Quality control',
        ready_for_delivery: 'Ready for delivery',
      },
      lifecycleChecklistsTitle: 'Checklist by phase',
      lifecycleOpenTab: 'Open phase',
      lifecycleDone: 'Done',
      lifecyclePending: 'Pending',
      lifecycleCancelledHint: 'Cancelled sale — no lifecycle checklist.',
      administrativeAdvancedTitle: 'Administrative stages (advanced)',
      administrativeTitle: 'Administrative stages',
      administrativeField: 'Administrative stage',
      macroPreparationField: 'Preparation stage (macro)',
      preparationTitle: 'Preparation tasks',
      timelineTitle: 'Timeline',
      saveStages: 'Save stages',
      stagesSaved: 'Stages updated',
      stagesError: 'Could not save stages',
      noTasks: 'No tasks yet. Use “Start preparation” when the sale is paid to generate the checklist.',
      taskStep: 'Step',
      taskStatus: 'Status',
      saveTask: 'Save',
      taskSaved: 'Task updated',
      taskError: 'Could not update task',
      timelineEmpty: 'No events',
      timelineLoadError: 'Could not load timeline',
      adminStages: {
        sale_created: 'Sale created',
        documentation_pending: 'Documentation pending',
        documentation_received: 'Documentation received',
        financing_in_progress: 'Financing in progress',
        financing_complete: 'Financing complete',
        commission_pending: 'Commission pending',
        commission_complete: 'Commission settled',
        ready_for_preparation: 'Ready for preparation',
      },
      prepStages: {
        not_started: 'Not started',
        preparation_pending: 'Preparation pending',
        mechanical_check: 'Mechanical check',
        detailing: 'Detailing',
        accessories_installation: 'Accessories',
        document_transfer: 'Document transfer',
        delivery_scheduled: 'Delivery scheduled',
        completed: 'Completed',
      },
      taskStatuses: {
        pending: 'Pending',
        in_progress: 'In progress',
        completed: 'Completed',
        skipped: 'Skipped',
      },
      stepKeys: {
        mechanical_check: 'Mechanical check',
        detailing: 'Detailing',
        accessories_installation: 'Accessories',
        document_transfer: 'Documentation / transfer',
        delivery_scheduled: 'Delivery scheduled',
        other: 'Other',
      },
      timelineEventTitles: {
        lead_history: 'Lead activity',
        proposal_created: 'Proposal created',
        proposal_sent: 'Proposal sent',
        proposal_approved: 'Proposal approved',
        sale_created: 'Sale recorded',
        sale_status_history: 'Sale status',
        entity_document: 'Document (sale)',
        vehicle_entity_document: 'Document (vehicle)',
        sale_payment_recorded: 'Sale payment',
        commission: 'Commission',
        sale_cost: 'Preparation cost',
        preparation_task_created: 'Preparation task',
        preparation_task_completed: 'Task completed',
        operational_stage_change: 'Operational stage',
        preparation_kanban_change: 'Preparation board',
        checklist_item_change: 'Checklist',
      },
    },
  },

  operation: {
    stages: {
      pos_venda: 'Post-sale',
      preparacao: 'Preparation',
      entrega: 'Delivery',
      pos_recebimento: 'Post-delivery',
      concluido: 'Completed',
    },
    postSale: {
      title: 'Post-sale',
      subtitle: 'Admin and finance before vehicle prep.',
    },
    preparation: {
      title: 'Preparation',
      subtitle: 'Workshop kanban — drag cards between columns.',
    },
    preparationDetail: {
      title: 'Preparation detail',
      subtitle: 'Operational view of the vehicle in preparation.',
      backToBoard: 'Back to kanban',
      loadError: 'Could not load preparation detail.',
      notFound: 'Preparation detail not found.',
      vehicleSectionTitle: 'Vehicle data',
      vehicleLabel: 'Vehicle',
      plate: 'Plate',
      year: 'Year',
      mileage: 'Mileage',
      customer: 'Customer',
      kanbanColumn: 'Kanban column',
      operationalCommentLabel: 'Operational comment',
      operationalCommentPlaceholder: 'Notes about how this operation is progressing.',
      timeInColumn: 'Time in this column',
      columnSince: 'Entered column at',
      checklistSectionTitle: 'Preparation checklist',
      checklistProgress: '{{done}} of {{total}} complete',
      saveChecklist: 'Save checklist',
      checklistSaved: 'Checklist updated.',
      checklistError: 'Could not update checklist.',
      tasksSectionTitle: 'Preparation tasks',
      selectAssignee: 'Select assignee',
      onlyUnassigned: 'Apply only to unassigned tasks',
      applyAssigneeToFlow: 'Apply assignee to flow',
      assigneeSaved: 'Task assignee updated.',
      assigneeError: 'Could not update task assignee.',
      bulkAssignSaved: 'Assignee applied to tasks.',
      bulkAssignError: 'Could not apply assignee to tasks.',
      saveAllSuccess: 'Changes saved successfully.',
      saveAllError: 'Could not save changes.',
      deliveryDateLabel: 'Delivery date',
      deliveryDatePlaceholder: 'Select date and time',
      deliveryAtSaved: 'Delivery date scheduled.',
      saveAll: 'Save',
      confirmDelivery: 'Confirm delivery',
      confirmDeliveryTitle: 'Confirm vehicle delivery',
      confirmDeliveryDescription: 'Are you sure you want to finalize this delivery? This will mark the sale as delivered and the vehicle as sold.',
      confirmDeliveryWarning: 'After confirming, the vehicle will be considered delivered and the sale will be finalized.',
      confirmDeliveryConfirm: 'Yes, confirm delivery',
      confirmDeliveryCancel: 'Cancel',
      deliveryConfirmed: 'Delivery confirmed successfully!',
      deliveryConfirmError: 'Could not confirm delivery.',
      noTasks: 'No preparation tasks registered.',
      unassigned: 'Unassigned',
      tabFlow: 'Flow',
      tabDocuments: 'Documents',
      tabComments: 'Comments',
      documentsTitle: 'Preparation documents',
      documentUploaded: 'Document uploaded successfully.',
      noDocuments: 'No documents uploaded.',
      uploadedDocuments: '{{count}} document(s) uploaded',
      saveComment: 'Save comment',
      commentSaved: 'Comment saved.',
    },
    deliveries: {
      title: 'Deliveries',
      subtitle: 'Vehicles ready for handover.',
    },
    postReceipt: {
      title: 'Post-delivery',
      subtitle: 'Follow-up after handover.',
    },
    loadError: 'Could not load sales.',
    refresh: 'Refresh',
    list: {
      date: 'Date',
      customer: 'Customer',
      vehicle: 'Vehicle',
      finalValue: 'Final value',
      progress: 'Checklist',
      details: 'Details',
      actions: 'Actions',
      pageOf: 'Page {{page}} of {{total}}',
    },
    empty: 'No sales in this stage.',
    salesInStage: 'Sales in this stage',
    value: 'Value',
    checklistProgress: '{{pct}}% checklist',
    advance: 'Advance stage',
    advanceOk: 'Stage updated.',
    advanceError: 'Could not advance stage.',
    timeline: {
      title: 'Timeline',
      empty: 'No comments or events yet.',
      newCommentPlaceholder: 'Write a comment…',
      addComment: 'Add comment',
      commentAdded: 'Comment added.',
      kanbanMoved: '{{actor}} moved the card on the preparation board: {{from}} → {{to}}',
      operationalStage: '{{actor}} changed the operational stage: {{from}} → {{to}}',
      preparationStage: '{{actor}} changed the preparation stage: {{from}} → {{to}}',
      checklist: '{{actor}} — {{title}}: {{action}}',
      checklistActionCompleted: 'completed',
      checklistActionReopened: 'reopened',
      checklistActionNotes: 'notes updated',
      unknownEvent: 'Recorded activity',
    },
    kanban: {
      boardTitle: 'Preparation',
      timeInColumn: 'Time in column',
      moved: 'Card updated.',
      moveError: 'Could not move card.',
      moveOnlyAdjacent: 'Moves are only allowed to the immediately previous or next column.',
      cannotMoveBackFromLast: 'After reaching the last column, moving back to previous stages is not allowed.',
      deliveryAtRequiredPrompt:
        'Enter the vehicle delivery date and time to move into the last column (format: YYYY-MM-DDTHH:mm).',
      deliveryAtInvalid: 'Invalid delivery date.',
      columnResponsible: 'Responsible: {{name}}',
      columnResponsibleEmpty: 'Unassigned',
      bayRequiresAssignee:
        'To move to the bay column, assign every preparation task to a user or set the delivery responsible on the sale.',
      noColumns: 'Configure the kanban so this stage can work.',
      nextPhase: 'Next phase',
      responsible: 'Owner',
      multipleAssignees: 'Multiple assignees',
      swipeHint: 'Swipe horizontally to see all columns.',
      columns: {
        awaiting_preparation: 'Waiting',
        in_preparation: 'In progress',
        quality_control: 'Quality control',
        ready_for_delivery_handoff: 'Ready for delivery',
      },
    },
    delivery: {
      scheduledAt: 'Delivery date',
      responsible: 'Responsible',
    },
    saleDetail: {
      checklistTitle: 'Current stage checklist',
      checklistEmpty: 'No checklist items. Configure a template.',
      configureCheckpoints: 'Configure post-sale checkpoints',
      checklistSaved: 'Checklist updated.',
      checklistError: 'Could not update checklist.',
      advance: 'Advance to next stage',
      advanceOk: 'Stage advanced.',
      advanceError: 'Could not advance.',
      deliveryTitle: 'Delivery details',
      deliveryAt: 'Delivery date and time',
      deliverySaved: 'Delivery saved.',
      deliveryError: 'Could not save delivery.',
    },
  },

  common: {
    name: 'Name',
    brand: 'Brand',
    model: 'Model',
    color: 'Color',
    mileage: 'Mileage',
    condition: 'Condition',
    fuel: 'Fuel',
    transmission: 'Transmission',
    doors: 'Doors',
    steering: 'Steering',
    bodyBrand: 'Body brand',
    bodyModel: 'Body model',
    operation: 'Operation',
    fleetNumber: 'Fleet no.',
    salePrice: 'Sale price',
    purchasePrice: 'Purchase price',
    photos: 'Photos',
    video: 'Video',
    km: 'km',
    warning: 'Warning',
    description: 'Description',
    status: 'Status',
    date: 'Date',
    price: 'Price',
    type: 'Type',
    category: 'Category',
    notes: 'Notes',
    active: 'Active',
    inactive: 'Inactive',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    none: 'None',
    never: 'Never',
    optional: 'Optional',
    required: 'Required',
    total: 'Total',
    notProvided: 'Not provided',
    continueEditing: 'Continue editing',
    loading: 'Loading...',
    noResults: 'No results found',
    typeAtLeastChars: 'Type at least {{count}} characters',
    min: 'Minimum',
    max: 'Maximum',
    days: {
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      sunday: 'Sun',
    },
    note: 'Note',
  },

  vehicles: {
    title: 'Vehicles',
    subtitle: 'Manage your dealership inventory',
    new: 'New Vehicle',
    edit: 'Edit Vehicle',
    details: 'Vehicle Details',
    list: 'Vehicle List',
    brand: 'Brand',
    model: 'Model',
    version: 'Version',
    year: 'Year',
    mileage: 'Mileage',
    color: 'Color',
    condition: 'Condition',
    fuelType: 'Fuel Type',
    transmission: 'Transmission',
    doors: 'Doors',
    branch: 'Branch',
    selectBranch: 'Select a branch',
    loadingBranches: 'Loading branches...',
    registration: {
      selectVehicleTypeTitle: 'Select vehicle type',
      vehicleCategoryLabel: 'Vehicle category *',
      selectBranchFirst: 'Select the branch first to see allowed categories.',
      noBranchesHint: 'No branches available. Add a branch in Dealership settings.',
      noCategoriesForBranch: 'This branch has no categories enabled. Update Dealership settings.',
      categoryLabels: {
        A: 'Motorcycle',
        B: 'Car',
        C: 'Truck',
        D: 'Bus',
      },
    },
    validation: {
      branchRequired: 'Select the vehicle branch',
      categoryRequired: 'Vehicle category is required',
      categoryNotAllowedForBranch: 'This category is not enabled for the selected branch',
    },
    salePrice: 'Sale Price',
    purchasePrice: 'Purchase Price',
    contactActions: {
      contact: 'Contact lead',
      duplicatePrompt: 'This customer is already registered. Do you want to update the existing record?',
      duplicateRedirect: 'Redirecting to update the existing record.',
      duplicateCancelled: 'Lead was not created due to duplication.',
    },
    filters: { title: 'Filters', clear: 'Clear' },
    noVehicles: 'No vehicles found',
    photos: 'Photos',
    features: 'Features',
    stats: {
      total: 'Total Vehicles',
      inStock: 'In Stock',
      totalValue: 'Total Value',
    },
    status: {
      inStock: 'In Stock',
      reserved: 'Reserved',
      sold: 'Sold',
      inTransit: 'In Transit',
    },
    search: {
      placeholder: 'Search by name, plate or chassis...',
    },
    view: {
      grid: 'Grid',
      list: 'List',
    },
    results: {
      one: 'vehicle found',
      multiple: 'vehicles found',
      withFilters: ' with active filters',
    },
    table: {
      vehicle: 'Vehicle',
      year: 'Year',
      price: 'Price',
      status: 'Status',
      km: 'KM',
      actions: 'Actions',
    },
    actions: {
      addVehicle: 'Add Vehicle',
      register: 'Register Vehicle',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
    },
    success: {
      deleted: 'Vehicle deleted successfully!',
      published: 'Vehicle published successfully!',
    },
    empty: {
      noVehicles: 'No vehicles registered',
      filters: 'No vehicles found',
      adjustFilters: 'Try adjusting the filters to see more results',
      addFirst: 'Add your first vehicle to inventory',
    },
    noIdentification: 'No identification',
    priceLabel: 'Sale price',
    dialog: {
      deleteTitle: 'Confirm Deletion',
      deleteDescription: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
      thisVehicle: 'this vehicle',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
    fields: {
      condition: 'Condition',
      category: 'Category',
    },
    category: 'Category',
    errors: {
      publish: 'Could not publish the vehicle.',
    },
    marketplaces: 'Marketplace Publications',
    publish: 'Publish',
    published: 'Published',
    vehicleCondition: {
      new_vehicle: 'Brand new',
      semi_new: 'Semi-new',
      used: 'Used',
    },
    vehicleStatus: {
      in_stock: 'In Stock',
      in_transit: 'In Transit',
      reserved: 'Reserved',
      sold: 'Sold',
    },
  },


  vehicleRegistration: {
    basic: {
      title: 'Informações Básicas do Veículo',
      branchLabel: 'Filial',
      branchLoadingPlaceholder: 'Carregando filiais...',
      branchPlaceholder: 'Selecione uma filial (opcional)',
      noBranchesWarning: 'Nenhuma filial ativa disponível.',
      noBranchSelectedInfo: 'Selecione uma filial para continuar.',
      nameLabel: 'Nome do Veículo',
      nameHint: 'Será preenchido automaticamente ao selecionar marca, modelo e ano',
      namePlaceholder: 'Será preenchido automaticamente',
      generateName: 'Gerar Nome',
      generateNameTitle: 'Gerar nome automaticamente',
      brandLabel: 'Marca',
      brandPlaceholder: 'Buscar marca...',
      brandEmpty: 'Nenhuma marca encontrada',
      modelLabel: 'Modelo',
      modelPlaceholder: 'Buscar modelo...',
      modelSelectBrandFirst: 'Selecione uma marca primeiro',
      modelEmpty: 'Nenhum modelo encontrado',
      conditionLabel: 'Condição',
      conditionPlaceholder: 'Selecione a condição',
      modelYearLabel: 'Ano Modelo',
      modelYearPlaceholder: 'Selecione o ano modelo',
      manufactureYearLabel: 'Ano de Fabricação',
      manufactureYearPlaceholder: 'Selecione o ano de fabricação',
      manufactureYearHint: 'Ano de fabricação pode ser igual ao ano modelo ou 1 ano anterior',
      colorLabel: 'Cor',
      primaryColorLabel: 'Cor Primária',
      secondaryColorLabel: 'Cor Secundária',
      colorPlaceholder: 'Selecione',
      colorOptionalPlaceholder: 'Selecione (opcional)',
      mileageLabel: 'Quilometragem',
      mileagePlaceholder: '50.000',
      mileageZeroPlaceholder: '0 km',
      mileageHint: 'Quilometragem definida automaticamente para veículos 0 km',
      mileageRequiredHint: 'Quilometragem *',
      mileageAutoHint: 'Quilometragem definida automaticamente para veículos 0 km',
    },
    pricing: {
      title: 'Vehicle pricing',
      description: 'Enter the prices manually; FIPE lookup is no longer used in this flow.',
      manualInfo: 'Sale, minimum, and purchase prices are entered manually.',
      salePriceTitle: 'Sale price',
      requiredBadge: 'Required',
      minimumPriceTitle: 'Minimum sale price',
      confidentialBadge: 'Confidential',
      confidentialInfoTitle: 'Confidential information',
      confidentialInfoMessage: 'The minimum value is private and will not be shown publicly. It is used only in negotiations and internal reports for margin control.',
      minPriceWarning: 'The minimum price cannot be greater than the sale price.',
      purchasePriceTitle: 'Purchase price',
      purchasePriceInfoMessage: 'This value is private and will not be shown publicly. It is used only in internal reports for margin analysis.',
      diffTitle: 'Difference',
      diffSubtitle: 'Sale − purchase value',
      minDiffTitle: 'Min. diff.',
      minDiffSubtitle: 'Minimum − purchase value',
      hidePricingLabel: 'Hide confidential values from sellers',
      hidePricingDescription: 'When enabled, the purchase price and minimum price are hidden from sellers in proposals and negotiations. Only administrators and managers can view these values.',
      activeBadge: 'Enabled',
      statusTitle: 'Vehicle status',
      statusDescription: 'Select the current vehicle status',
      statusLabel: 'Status',
      statusPlaceholder: 'Select a status',
    },
    specifications: {
      carTitle: 'Especificações Técnicas',
      motorcycleTitle: 'Especificações Técnicas da Motocicleta',
      truckTitle: 'Especificações Técnicas do Caminhão',
      busTitle: 'Especificações Técnicas do Ônibus',
      fuelLabel: 'Combustível',
      transmissionLabel: 'Transmissão',
      automaticHint: 'Automático — padrão para veículos elétricos/híbridos',
      formHint: 'Informado no formulário',
      bodyTypeLabel: 'Tipo de Carroceria',
      bodyTypePlaceholder: 'Selecione o tipo de carroceria',
      bodyTypeShortPlaceholder: 'Selecione o tipo',
      doorsLabel: 'Número de Portas',
      doorsPlaceholder: '4',
      steeringLabel: 'Direção',
      steeringPlaceholder: 'Selecione a direção',
      motorcycleEngineLabel: 'Tipo de Motor',
      motorcycleCoolingLabel: 'Tipo de Refrigeração',
      motorcycleStarterLabel: 'Tipo de Partida',
      motorcycleFeedingLabel: 'Tipo de Alimentação',
      motorcycleFrontBrakeLabel: 'Freio Dianteiro',
      motorcycleRearBrakeLabel: 'Freio Traseiro',
      motorcycleGearsLabel: 'Número de Marchas',
      motorcycleGearsPlaceholder: '6',
      motorcycleCylinderLabel: 'Cilindrada (cc)',
      motorcycleCylinderPlaceholder: '150',
      motorcycleStyleLabel: 'Estilo',
      motorcycleCategoryLabel: 'Categoria',
      truckBodyTypeLabel: 'Tipo de Carroceria',
      truckBodyTypePlaceholder: 'Selecione a carroceria',
      truckCabTypeLabel: 'Tipo de Cabine',
      truckCabTypePlaceholder: 'Selecione a cabine',
      truckTractionLabel: 'Tração',
      truckTractionPlaceholder: 'Selecione a tração',
      truckAxlesLabel: 'Número de Eixos',
      truckAxlesPlaceholder: '3',
      truckGrossVehicleWeightLabel: 'PBT — Peso Bruto Total (kg)',
      truckGrossVehicleWeightPlaceholder: '23000',
      truckPayloadLabel: 'Capacidade de Carga (kg)',
      truckPayloadPlaceholder: '15000',
      truckTiresLabel: 'Quantidade de Pneus',
      truckTiresPlaceholder: '6',
      busBodyBrandLabel: 'Marca da Carroceria',
      busBodyBrandPlaceholder: 'Selecione',
      busBodyModelLabel: 'Modelo da Carroceria',
      busBodyModelPlaceholder: 'Ex: Paradiso, Torino, Apache...',
      busOperationTypeLabel: 'Tipo de Operação',
      busOperationTypePlaceholder: 'Selecione',
      busFleetNumberLabel: 'Número de Frota',
      busFleetNumberPlaceholder: 'Ex: 1042',
      busSeatedCapacityLabel: 'Capacidade Sentada',
      busSeatedCapacityPlaceholder: '44',
      busStandingCapacityLabel: 'Capacidade em Pé',
      busStandingCapacityPlaceholder: '20',
      busWheelchairCapacityLabel: 'Vagas para Cadeirante',
      busWheelchairCapacityPlaceholder: '2',
      featuresTitle: 'Itens e Opcionais do Veículo',
      busFeaturesTitle: 'Equipamentos do Ônibus',
      featuresDescription: 'Selecione os itens e características que o veículo possui (opcional)',
      featuresTipTitle: 'Dica:',
      featuresTipMessage: 'Selecione apenas as características que o veículo realmente possui. Isso ajuda os clientes a encontrar exatamente o que procuram.',
      comfortGroupTitle: 'Conforto',
      safetyGroupTitle: 'Segurança',
      technologyGroupTitle: 'Tecnologia',
      convenienceGroupTitle: 'Conveniência',
      performanceGroupTitle: 'Performance',
      lightingGroupTitle: 'Iluminação',
      adasGroupTitle: 'Sistemas Avançados (ADAS)',
      busEquipmentGroupTitle: 'Equipamentos',
      armorTitle: 'Blindagem e Categoria Especial',
      armorDescription: 'Configure se o veículo possui blindagem ou categoria especial',
      armorLabel: 'Nível de Blindagem',
      armorPlaceholder: 'Selecione o nível de blindagem',
      specialCategoryLabel: 'Categoria Especial',
      specialCategoryPlaceholder: 'Selecione a categoria especial',
      armorOptionalTitle: 'Opcional:',
      armorOptionalMessage: 'Configure apenas se o veículo possuir blindagem ou categoria especial (ex: táxi, ambulância, etc).',
      otherCharacteristicsTitle: 'Outras Características',
      otherCharacteristicsDescription: 'Características adicionais e diferenciais do veículo',
      otherCharacteristicsOptionalMessage: 'Selecione características adicionais que destacam o veículo (ex: único dono, revisões em dia, etc).',
      legalTitle: 'Legal Status',
      legalDescription: 'Indicate if there is any lien or financial restriction on the vehicle',
      alienatedLabel: 'Alienated Vehicle / With Financing',
      alienatedActiveDescription: 'This vehicle has active financing. Indicate the debt value in trade proposals.',
      alienatedInactiveDescription: 'Indicate if there is any financing, consortium or fiduciary alienation on this vehicle.',
      selectPlaceholder: 'Select',
      fuelSelectPlaceholder: 'Select the fuel type',
      transmissionSelectPlaceholder: 'Select the transmission',
    },
    documentation: {
      title: 'Vehicle documentation',
      plateLabel: 'License plate',
      chassisLabel: 'Chassis',
      chassisPlaceholder: '9BWZZZ377VT004251',
      renavamLabel: 'RENAVAM',
      renavamPlaceholder: '00000000000',
      documentsLabel: 'Vehicle documents',
      addDocumentsLabel: 'Add new documents',
      documentsHint: 'Upload documents such as registration, invoice, etc. Select a category for each document. Accepted formats: PDF, JPG, PNG',
      inspectedLabel: 'Vehicle inspected',
      inspectedDescription: 'Check if the vehicle has passed a technical inspection',
      inspectedBadge: 'Inspected',
      inspectionDateLabel: 'Inspection date',
      inspectionDatePlaceholder: 'Select the inspection date',
      inspectionTitle: 'Inspection and Survey',
      auctionTitle: 'Auction information',
      auctionLabel: 'Auction vehicle',
      auctionDescription: 'Check if this vehicle came from an auction',
      auctionBadge: 'Auction',
      auctionCategoryLabel: 'Auction category',
      auctionCategoryPlaceholder: 'Select a category',
      auctionSubtypeLabel: 'Subtype',
      auctionSubtypePlaceholder: 'Select a subtype',
      damageLevelLabel: 'Damage level',
      damageLevelPlaceholder: 'Select the damage level',
      importanceTitle: 'Important:',
      importanceMessage: 'Auction information is important for customer transparency. Always indicate if the vehicle came from an auction and its damage level, if any.',
      descriptionTitle: 'Vehicle description',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Example: Vehicle in excellent condition, one owner, all services up to date, manual and spare key...',
      descriptionSubtitle: 'Describe the vehicle in an attractive and detailed way',
      descriptionHint: 'Minimum 10 characters. Highlight the main differentiators.',
      tipTitle: 'Tip:',
      tipMessage: 'A good description increases the chances of a sale. Mention:',
      tip1: 'Vehicle condition',
      tip2: 'Maintenance and service history',
      tip3: 'Main features and extras',
      tip4: 'Updated documentation',
      tip5: 'Trade-in or financing accepted (if applicable)',
      descriptionHintEdit: 'Highlight the main differentials and conservation state',
      auctionDamageLabel: 'Damage Level',
      auctionDamagePlaceholder: 'Select the damage level',
      auctionImportantMessage: 'Auction information matters for transparency with the customer. Always disclose whether the vehicle came from an auction and its damage level, if any.',
      auctionImportantTitle: 'Important:',
      descriptionDescription: 'Describe the vehicle in an appealing and detailed way',
      descriptionTipConservation: "Vehicle's condition",
      descriptionTipDifferentials: 'Key highlights and options',
      descriptionTipDocumentation: 'Documentation in order',
      descriptionTipMaintenance: 'Maintenance and service history',
      descriptionTipMessage: 'A good description increases the chances of a sale. Mention:',
      descriptionTipTitle: 'Tip:',
      descriptionTipTradeOrFinance: 'Accepts trade-in or financing (if applicable)',
    },
    summary: {
      title: 'Resumo Final — Revise as Informações',
      description: 'Revise todas as informações antes de finalizar o cadastro',
      readyTitle: 'Ready to save!',
      readyMessage: 'Review all information below before completing the registration.',
      basicSectionTitle: 'Basic information',
      valuesSectionTitle: 'Values',
      technicalSectionTitle: 'Technical specifications',
      documentationSectionTitle: 'Documentation',
      descriptionSectionTitle: 'Description',
      mediaSectionTitle: 'Media',
      nameLabel: 'Name',
      brandLabel: 'Brand',
      modelLabel: 'Model',
      conditionLabel: 'Condition',
      modelYearAndManufactureYearLabel: 'Model year / Manufacture year',
      colorLabel: 'Color',
      mileageLabel: 'Mileage',
      salePriceLabel: 'Sale price',
      minimumPriceLabel: 'Minimum price',
      purchasePriceLabel: 'Purchase price',
      statusLabel: 'Status',
      fuelLabel: 'Fuel',
      transmissionLabel: 'Transmission',
      typeLabel: 'Type',
      doorsLabel: 'Doors',
      steeringLabel: 'Steering',
      busBodyBrandLabel: 'Body brand',
      busBodyModelLabel: 'Body model',
      busOperationTypeLabel: 'Operation',
      busFleetNumberLabel: 'Fleet no.',
      plateLabel: 'Plate',
      chassisLabel: 'Chassis',
      renavamLabel: 'RENAVAM',
      inspectionLabel: 'Inspection',
      inspectionValuePrefix: 'Inspected on',
      inspectionDateMissing: 'Date not provided',
      auctionLabel: 'Auction',
      auctionValue: 'Auction vehicle',
      descriptionLabel: 'Vehicle description',
      photosLabel: 'Photos',
      photoSelectedOne: '1 photo selected',
      photoSelectedMany: '{{count}} photos selected',
      videoLabel: 'Video',
      warningTitle: 'Warning:',
      warningMessage: 'Review all information before finishing. You can edit this information later if needed.',
    },
  },

  leads: {
    title: 'Leads',
    new: 'New Lead',
    edit: 'Edit Lead',
    details: 'Lead Details',
    clientInfo: 'Client Information',
    vehicleInterests: 'Vehicle Interests',
    preferences: 'Client Preferences',
    source: 'Source',
    seller: 'Seller',
    autoTransfer: {
      title: 'Automatic Transfer',
      description: 'Configure rules to automatically transfer leads',
      defaultSeller: 'Default seller (fallback)',
      defaultSellerHint:
        'When no rule matches a lead, assignment falls back to this seller. Optional.',
      defaultSellerNone: 'No default seller',
      defaultSellerSaved: 'Default seller updated.',
      defaultSellerError: 'Could not save default seller.',
      returnRuleTitle: 'Return rule (mandatory)',
      returnRuleHint:
        'This rule has priority over all others. Define when a lead can return to the previous seller.',
      alwaysReturn: 'Always return to previous seller',
      unitHours: 'Hours',
      unitDays: 'Days',
      unitMonths: 'Months',
      returnRuleSaved: 'Return rule updated.',
      returnRuleError: 'Could not save return rule.',
      returnRuleInvalid: 'Enter an integer value greater than zero.',
      tabRules: 'Rules',
      tabHistory: 'History',
      historyTitle: 'Change history',
      historyEmpty: 'No changes recorded yet.',
      historyLoadError: 'Could not load history.',
      historyOldValues: 'Before',
      historyNewValues: 'After',
      historyActionToggle: 'Auto transfer activation',
      historyActionDefaultSeller: 'Default seller',
      historyActionReturnRule: 'Return rule',
      historyActionRuleCreated: 'Rule created',
      historyActionRuleUpdated: 'Rule updated',
      historyActionRuleDeleted: 'Rule deleted',
      historyActionRulesReordered: 'Rules reordered',
      enabled: 'Enabled',
      addRule: 'New Rule',
      addFirstRule: 'Add first rule',
      noRules: 'No rules configured',
      conditions: 'conditions',
      inactive: 'Inactive',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'e.g.: São Paulo Clients',
      assignedUsers: 'Sellers',
      selectUsers: 'Select sellers',
      branch: 'Branch',
      selectBranch: 'Select branch',
      allBranches: 'All branches',
      branchDesc: 'Rules are applied only to the selected branch',
      branches: 'Branches',
      selectBranches: 'Select branches',
      branchesDesc: 'Select one or more branches. Leave empty to apply to all.',
      searchUsers: 'Search sellers',
      editRule: 'Edit Rule',
      newRule: 'New Rule',
      confirmDelete: 'Are you sure you want to delete this rule?',
      // Rule type
      ruleType: 'Rule Type',
      byCharacteristics: 'By Characteristics',
      bySpecificVehicles: 'By Specific Vehicles',
      byCharacteristicsDesc: 'Distribute leads based on characteristics like brand, model, price, location, etc.',
      bySpecificVehiclesDesc: 'Distribute leads based on specific vehicles from your inventory.',
      selectVehicles: 'Select vehicles',
      searchVehicles: 'Search vehicles',
      removeVehicle: 'Remove vehicle',
      // Form sections
      geographicFilters: 'Geographic Filters',
      geographicFiltersDesc: 'Define regions, cities and neighborhoods',
      vehicleFilters: 'Vehicle Filters',
      vehicleFiltersDesc: 'Specify vehicle characteristics',
      priceAndRange: 'Price and Year Ranges',
      priceAndRangeDesc: 'Set price, year and mileage limits',
      schedule: 'Business Hours',
      scheduleDesc: 'Set days and hours for distribution',
      leadSources: 'Lead Sources',
      leadSourcesDesc: 'Select from which sources leads will be distributed',
      // Geographic fields
      regions: 'Regions',
      regionsPlaceholder: 'Select regions',
      regionNorth: 'North',
      regionNortheast: 'Northeast',
      regionMidwest: 'Midwest',
      regionSoutheast: 'Southeast',
      regionSouth: 'South',
      states: 'States',
      selectStates: 'Select states',
      searchStates: 'Search states',
      cities: 'Cities',
      selectCities: 'Select cities',
      searchCities: 'Search cities',
      selectStatesFirst: 'Select states first',
      citiesPlaceholder: 'Select cities',
      neighborhoods: 'Neighborhoods',
      neighborhoodsPlaceholder: 'Enter neighborhoods',
      searchNeighborhoods: 'Search neighborhoods',
      zipCodes: 'ZIP Codes',
      zipCodesPlaceholder: 'Enter ZIP codes',
      // Vehicle fields
      categories: 'Categories',
      categoriesPlaceholder: 'Select categories',
      vehicleTypes: 'Vehicle Types',
      vehicleTypesPlaceholder: 'Select types',
      vehicleConditions: 'Condition',
      vehicleConditionsPlaceholder: 'New, Used, Certified',
      brands: 'Brands',
      brandsPlaceholder: 'Select brands',
      selectCategoriesFirst: 'Select categories first',
      models: 'Models',
      modelsPlaceholder: 'Select models',
      selectBrandsFirst: 'Select brands first',
      versions: 'Versions',
      versionsPlaceholder: 'Select versions',
      fuelTypes: 'Fuel Type',
      fuelTypesPlaceholder: 'Select types',
      transmissions: 'Transmission',
      transmissionsPlaceholder: 'Select types',
      colors: 'Colors',
      colorsPlaceholder: 'Select colors',
      armorLevels: 'Armor Levels',
      armorLevelsPlaceholder: 'Select levels',
      // Ranges
      yearRange: 'Vehicle Year',
      minYear: 'Minimum Year',
      maxYear: 'Maximum Year',
      priceRange: 'Price Range',
      minPrice: 'Minimum Price',
      maxPrice: 'Maximum Price',
      mileageRange: 'Mileage',
      minMileage: 'Minimum Mileage',
      maxMileage: 'Maximum Mileage',
      // Schedule
      scheduleDays: 'Days of Week',
      scheduleStart: 'Start Time',
      scheduleEnd: 'End Time',
      // Sources
      sources: 'Sources',
      sourcesPlaceholder: 'Select sources',
      leadSourceKeys: 'Source Keys',
      leadSourceKeysPlaceholder: 'Enter keys',
      // Common options
      new: 'New',
      used: 'Used',
      // Feedback messages
      ruleNameRequired: 'Rule name is required',
      selectUsersRequired: 'Select at least one salesperson',
      ruleCreatedSuccess: 'Rule created successfully!',
      ruleUpdatedSuccess: 'Rule updated successfully!',
      ruleSaveError: 'Error saving rule. Please try again.',
      reorderSuccess: 'Rule order updated successfully!',
      reorderError: 'Error reordering rules. Please try again.',
      deleteRuleTitle: 'Delete rule?',
      deleteRuleDescription: 'Are you sure you want to delete the rule "{{name}}"? This action cannot be undone.',
      deleteRuleDescriptionGeneric: 'Are you sure you want to delete this rule? This action cannot be undone.',
      ruleDeletedSuccess: 'Rule deleted successfully!',
      deleteError: 'Error deleting rule. Please try again.',
      certified: 'Certified Pre-Owned',
      car: 'Car',
      motorcycle: 'Motorcycle',
      truck: 'Truck',
      gasoline: 'Gasoline',
      diesel: 'Diesel',
      electric: 'Electric',
      flex: 'Flex',
      hybrid: 'Hybrid',
      manual: 'Manual',
      automatic: 'Automatic',
      cvt: 'CVT',
      automatedManual: 'Automated Manual',
    },
    form: {
      vehicle: 'Vehicle',
      searchVehicle: 'Search vehicle by name, brand or model...',
      personTypePF: 'Individual',
      personTypePJ: 'Company',
      documentCpfPlaceholder: '000.000.000-00',
      documentCnpjPlaceholder: '00.000.000/0000-00',
      documentCpfHint: 'Enter 11 digits for CPF',
      documentCnpjHint: 'Enter 14 digits for CNPJ',
      documentCpfValid: 'CPF valid',
      documentCnpjValid: 'CNPJ valid',
      documentCpfTitle: 'CPF - Individual Registration',
      documentCnpjTitle: 'CNPJ - National Registry of Legal Entities',
      documentTypeHint: 'Choose the document type before entering the number.',
      duplicateFoundTitle: 'Client already registered',
      duplicateFoundMessage: 'A registration already exists for this client.',
      goToEdit: 'Go to Edit',
      checkingPhone: 'Checking phone...',
      checkingDocument: 'Checking document...',
      documentDuplicateCPF: 'This CPF is already registered for client: {{name}}',
      documentDuplicateCNPJ: 'This CNPJ is already registered for client: {{name}}',
      // Form fields
      fullName: 'Full Name',
      fullNamePlaceholder: 'Enter full name',
      documentLabel: 'Document',
      cnhLabel: 'Driver License',
      phonesLabel: 'Phones',
      emailsLabel: 'Emails',
      initialMessageLabel: 'Initial Message',
      messageLabel: 'Message',
      messagePlaceholder: 'Enter the client\'s initial message...',
      personalInfoTitle: 'Personal Information',
      personalInfoDescription: 'Identification and core lead data.',
      contactsTitle: 'Contacts',
      contactsDescription: 'Phone and email to keep following up with the lead.',
      vehicleInterestTitle: 'Vehicle Search',
      vehicleInterestDescription: 'Lead interests to guide the outreach.',
      messageDescription: 'Initial context shared by the client.',
      exit: 'Exit',
      openExisting: 'Open Client',
    },
    filters: {
      title: 'Filters',
      search: 'Search',
      searchPlaceholder: 'Name, phone, email...',
      name: 'Name',
      namePlaceholder: 'Filter by name',
      phone: 'Phone',
      phonePlaceholder: 'Filter by phone',
      email: 'Email',
      emailPlaceholder: 'Filter by email',
      document: 'Document',
      documentPlaceholder: 'CPF/CNPJ',
      status: 'Status',
      source: 'Source',
      serviceUser: 'Service user',
      serviceUserPlaceholder: 'Select user',
      vehicleInterest: 'Vehicle of interest',
      vehicleInterestPlaceholder: 'Search vehicle...',
      hasProposal: 'Has proposal',
      hasPreferences: 'Has preferences',
      funnelStage: 'Funnel stage',
      converted: 'Converted',
      createdAtFrom: 'Created at (from)',
      createdAtTo: 'Created at (to)',
      all: 'All',
      yes: 'Yes',
      no: 'No',
      clearFilters: 'Clear filters',
      applyFilters: 'Apply',
      clear: 'Clear',
      customerData: 'Customer Data',
      createdAt: 'Created At',
      proposalConversion: 'Proposal & Conversion',
    },
    status: {
      new: 'New',
      contacted: 'Contacted',
      qualified: 'Qualified',
      proposal: 'Proposal',
      negotiating: 'Negotiating',
      negotiation: 'Negotiating',
      converted: 'Converted',
      won: 'Won',
      lost: 'Lost',
    },
    kanban: {
      funnelNotConfiguredTitle: 'Sales funnel not configured',
      funnelNotConfiguredDescription:
        'To view leads in Kanban mode, configure a sales funnel. Go to lead settings to create your funnel.',
      configureFunnelLink: 'Configure sales funnel',
      advanceRequiresAssignee:
        'Assign a salesperson to the lead before moving to the next stage.',
      moveToPreviousStage: 'Move to previous stage',
      moveToNextStage: 'Move to next stage',
      nextStageRequiresAssignee: 'Assign a salesperson to move forward',
      stageUpdated: 'Stage updated.',
      stageUpdateFailed: 'Could not update the stage.',
    },
    drawer: {
      openWhatsAppConversations: 'Open WhatsApp inbox',
      assignSalesperson: 'Salesperson',
      assignSalespersonPlaceholder: 'Search salesperson…',
      saveAssignee: 'Save salesperson',
      assigneeUpdated: 'Salesperson updated.',
      assigneeUpdateFailed: 'Could not update salesperson.',
      savingAssignee: 'Saving…',
    },
    report: {
      title: 'Leads report',
      subtitle:
        'Tabular view using the same filters as the list. Export CSV with all stored lead fields.',
      exportCsv: 'Export CSV',
      exporting: 'Generating file…',
      exportSuccess: 'Download started.',
      exportError: 'Could not export the report.',
      exportHint: 'The CSV includes address, preferences, financing, vehicle interests, and more.',
      showingCount: 'Showing {{count}} of {{total}} leads (preview up to 500 rows).',
      column: {
        name: 'Name',
        document: 'Document',
        status: 'Status',
        source: 'Source',
        phone: 'Phone',
        email: 'Email',
        assigned: 'Owner',
        stage: 'Stage',
        createdAt: 'Created at',
      },
      filters: {
        dateFrom: 'Date from',
        dateTo: 'Date to',
        media: 'Media',
        allMedia: 'All media',
        stage: 'Stage',
        allStages: 'All stages',
        status: 'Status',
        allStatuses: 'All statuses',
        phone: 'Phone',
        phonePlaceholder: 'Enter phone',
        email: 'Email',
        emailPlaceholder: 'Enter email',
        clear: 'Clear filters',
      },
    },
    contactActions: {
      contact: 'Get in touch',
      duplicateCancelled: 'Record not created due to duplication.',
      duplicateFoundMessage: 'A record for this customer already exists.',
      duplicateFoundTitle: 'Customer already registered',
      duplicatePrompt: 'A record already exists for this customer, do you want to update the data?',
      duplicateRedirect: 'Redirecting to update the existing record.',
      exit: 'Exit',
      openClient: 'Open Customer',
    },
  },

  leadsSettingsHub: {
    title: 'Lead Settings',
    subtitle: 'Centralize lead intake, funnel, and distribution settings.',
    comingSoon: 'Coming soon',
    cards: {
      kanban: {
        title: 'Kanban',
        description: 'Configure lead funnel stages and rules.',
      },
      omnichannel: {
        title: 'Omnichannel',
        description: 'Unified customer support and channel handling.',
      },
      integrations: {
        title: 'Integrations',
        description: 'Connect lead capture platforms and channels.',
      },
      webhooks: {
        title: 'Webhooks',
        description: 'Configure endpoints and payloads for lead intake.',
      },
      distribution: {
        description: 'Manage automatic lead distribution rules.',
        title: 'Distribution',
      },
      whatsapp: {
        description: 'Configure the WhatsApp Business API integration.',
        title: 'WhatsApp',
      },
    },
    integrations: {
      title: 'Lead Integrations',
      subtitle: 'Configure integrations with lead acquisition channels.',
      placeholder: 'This area will be enabled in a future release.',
    },
    webhooks: {
      title: 'Lead Webhooks',
      subtitle: 'Configure webhooks and use the public endpoint to receive leads.',
      publicEndpointTitle: 'Public endpoint for lead intake',
      payloadExampleTitle: 'View JSON payload example',
      curlExampleTitle: 'View cURL example',
      payloadHint: 'Expected payload: name, phones [{ ddi, ddd, phone }], optionally email, message and vehicleReference.',
      newTitle: 'New webhook',
      editTitle: 'Edit webhook',
      listTitle: 'Configured webhooks',
      create: 'Create webhook',
      saveEdit: 'Save changes',
      empty: 'No webhooks configured.',
      saved: 'Webhook saved successfully.',
      removed: 'Webhook removed successfully.',
      fields: {
        name: 'Name',
        media: 'Media',
        mediaPlaceholder: 'Select...',
        active: 'Active',
      },
      errors: {
        required: 'Fill in name and media.',
        save: 'Could not save webhook.',
        delete: 'Could not remove webhook.',
      },
    },
  },

  leadMediaSettings: {
    title: 'Lead Media Catalog',
    subtitle: 'Create custom media and review the global catalog served by the API.',
    createTitle: 'New dealership media',
    sections: {
      catalogGlobal: 'Global catalog',
      custom: 'Dealership media',
    },
    tier: {
      spotlight: 'Spotlight',
      standard: 'Standard',
    },
    fields: {
      key: 'Technical key',
      label: 'Display name',
      color: 'Color (hex)',
      sortOrder: 'Order',
      active: 'Active',
    },
    actions: {
      create: 'Create media',
      clear: 'Clear',
    },
    success: {
      saved: 'Media saved successfully.',
      deleted: 'Media removed successfully.',
    },
    errors: {
      load: 'Could not load media.',
      required: 'Fill in media key and name.',
      save: 'Could not save media.',
      delete: 'Could not remove media. Check if it is in use.',
    },
    emptyCatalog: 'No entries in the global catalog.',
    emptyCustom: 'No custom media registered.',
    readOnly: 'Read only',
    active: 'active',
    inactive: 'inactive',
    meta: 'key: {{key}} | order: {{order}} | {{status}}',
    metaCatalog: 'key: {{key}} | order: {{order}} | {{tier}}',
  },

  leadWorkingMedia: {
    title: 'Media your dealership works with',
    subtitle: 'Select global catalog media your dealership uses in day-to-day operation.',
    catalogTitle: 'Media catalog',
    empty: 'No media available.',
    active: 'Active',
    inactive: 'Inactive',
    rowAria: '{{label}}. Status: {{state}}. Press to toggle.',
    meta: 'key: {{key}} | {{tier}}',
    tier: {
      spotlight: 'Spotlight',
      standard: 'Standard',
    },
    success: {
      updated: 'Selection updated successfully.',
    },
    errors: {
      load: 'Could not load media.',
      update: 'Could not update selection.',
      keepNotInformed: '"Not informed" must stay selected.',
    },
  },

  proposals: {
    title: 'Proposals',
    new: 'New Proposal',
    edit: 'Edit Proposal',
    details: 'Proposal Details',
    form: {
      financialProposalTitle: 'Financial proposal',
      invalidNegotiatedPrice: 'Invalid value.',
      advertisedPrice: 'Advertised price',
      negotiatedVehicleValue: 'Negotiated vehicle value',
      applyVehicleAdvertisedPrice: 'Vehicle value',
      selectVehicleForPrices:
        'Select a vehicle in the previous step to see the advertised price.',
      referenceSectionTitle: 'Price reference',
      negotiationSectionTitle: 'Negotiation',
      financialIntro:
        'Set prices, benefits and charges that make up the amount for the customer.',
      paymentsMustBePositive: 'Every payment must be greater than R$ 0.00.',
      paymentsMustCoverFinalPrice:
        'Payment totals must cover the proposal final amount. Adjust payments before continuing or saving.',
      searchVehicle: 'Search vehicle by name, brand or model...',
      vehicle: 'Vehicle',
    },
    actions: {
      acceptProposal: 'Accept proposal',
      rejectProposal: 'Decline proposal',
      dialogAcceptTitle: 'Accept proposal',
      dialogRejectTitle: 'Decline proposal',
      dialogAcceptBody:
        'Are you sure you want to accept this proposal? A sale will be created and the vehicle will be marked as sold.',
      dialogRejectBody:
        'Are you sure you want to decline this proposal? This action cannot be undone.',
      confirmAccept: 'Yes, accept',
      confirmReject: 'Yes, decline',
      toastAccepted: 'Proposal accepted successfully!',
      toastRejected: 'Proposal declined successfully!',
      toastAcceptError: 'Could not accept the proposal. Please try again.',
      toastRejectError: 'Could not decline the proposal. Please try again.',
    },
  },

  customers: {
    edit: {
      title: 'Edit customer',
      sectionContact: 'Contact',
      sectionAddress: 'Address',
      sectionNotes: 'Notes',
      name: 'Name',
      documentCpf: 'CPF',
      documentCnpj: 'CNPJ',
      documentReadOnlyHint: 'Document cannot be changed.',
      email: 'Email',
      phone: 'Phone',
      notes: 'Notes',
      save: 'Save',
      loadError: 'Could not load customer.',
      saveError: 'Could not save.',
      saveSuccess: 'Customer updated.',
      sectionFunnelOrigin: 'Funnel history (origin lead)',
      originLeadName: 'Name on lead',
      originLeadSource: 'Source',
      originLeadStatus: 'Stage',
      originLeadCreatedAt: 'Created at',
      originLeadConvertedAt: 'Converted at',
      originLeadMessage: 'Initial message',
      originLeadNotes: 'Funnel notes',
      openOriginLead: 'Open lead',
    },
    address: {
      zipCode: 'ZIP code',
      lookupZip: 'Look up ZIP',
      zipInvalid: 'Enter a ZIP code with 8 digits.',
      street: 'Street',
      number: 'Number',
      complement: 'Apt / suite',
      neighborhood: 'Neighborhood',
      city: 'City',
      state: 'State',
      searchingZip: 'Looking up ZIP...',
      zipLookupError: 'Could not look up ZIP code.',
    },
  },

  financial: {
    title: 'Financial',
    commissionRules: 'Commission Rules',
    newRule: 'New Rule',
    editRule: 'Edit Rule',
    basicConfig: 'Basic Configuration',
    advancedRules: 'Advanced Rules',
    validity: 'Validity',
    commissionType: 'Commission Type',
    percentage: 'Percentage',
    fixed: 'Fixed Value',
    mixed: 'Mixed',
    applicableTo: 'Applicable To',
    salesperson: 'Salesperson',
    manager: 'Manager',
    dealership: 'Dealership',
    isMandatoryCommission: 'Mandatory commission on sale',
    isMandatoryCommissionHint:
      'When enabled, the rule is applied automatically on the sale and amounts cannot be changed.',
    mandatoryRuleBadge: 'Required',
  },

  settings: {
    title: 'Settings',
    theme: 'Theme',
    language: 'Language',
    notifications: 'Notifications',
    operationPipeline: {
      cardTitle: 'Operational pipeline',
      cardDescription: 'Kanban columns and checklist templates per stage.',
      pageTitle: 'Operational pipeline',
      pageSubtitle: 'Configure kanban columns (preparation and post-delivery) and checklist templates.',
      tabKanban: 'Kanban',
      tabChecklists: 'Checklists',
      kanbanTitle: 'Board columns',
      boardStage: 'Board stage',
      active: 'Active',
      handoff: 'Handoff column',
      columnResponsible: 'Column assignee',
      columnResponsibleEmpty: 'Unassigned',
      newColumnTitle: 'New column',
      newColumnPlaceholder: 'e.g. Detailing',
      addColumn: 'Add column',
      kanbanLoadError: 'Could not load columns.',
      columnCreated: 'Column created.',
      columnSaveError: 'Could not save column.',
      columnDeleted: 'Column removed.',
      columnDeleteError: 'Could not remove column.',
      reorderOk: 'Order updated.',
      reorderError: 'Could not reorder.',
      confirmDeleteColumn: 'Delete column?',
      confirmDeleteColumnHint:
        'All vehicles in this column will be moved to the previous column. Checklist items tied to this column will be removed. This cannot be undone.',
      edgeColumnBadge: 'Pinned',
      edgeColumnHelp: 'The first and last columns cannot be edited or deleted.',
      columnChecklistTitle: 'Checklist for this column',
      columnChecklistHelp:
        'Items shown as a checklist when a sale is in this column. This matches the template linked to the column.',
      columnChecklistLines: 'Items',
      columnChecklistPlaceholder: 'e.g. Exterior wash\nAccessory checklist',
      checklistItemPlaceholder: 'Item text',
      addChecklistItem: 'Add item',
      removeChecklistItem: 'Remove item',
      templateItemsEmpty: 'No items in this template.',
      saveColumnChecklist: 'Save column checklist',
      columnChecklistSaved: 'Column checklist saved.',
      columnChecklistError: 'Could not save the column checklist.',
      checklistsTitle: 'Checklist templates',
      filterStage: 'Filter by stage',
      allStages: 'All stages',
      items: 'items',
      noTemplates: 'No templates yet.',
      newTemplate: 'New template',
      templateStage: 'Operational stage',
      itemsLines: 'Items (one per line)',
      itemsPlaceholder: 'Documentation\nFinal inspection\nCustomer training',
      createTemplate: 'Create template',
      templateFormInvalid: 'Enter a name and at least one item.',
      templateCreated: 'Template created.',
      templateSaveError: 'Could not save template.',
      templateDeleted: 'Template removed.',
      templateDeleteError: 'Could not delete template.',
      checklistLoadError: 'Could not load templates.',
      confirmDeleteTemplate: 'Delete template?',
      confirmDeleteTemplateHint: 'New sales will stop receiving this template automatically. Existing sale items are not removed.',
      tabSaleOnboarding: 'Sale pre-pipeline',
      saleOnboardingIntro:
        'Define required documents and contract templates before sending a sale from finance to operational preparation.',
      onboardingLoadError: 'Could not load pre-pipeline settings.',
      onboardingDocTypesTitle: 'Document types',
      onboardingContractTemplatesTitle: 'Contract templates',
      onboardingSlug: 'Slug',
      onboardingAttach: 'Where files attach',
      onboardingAttachSale: 'On the sale',
      onboardingAttachCustomer: 'On the customer profile',
      onboardingSort: 'Display order',
      onboardingRequired: 'Required',
      onboardingDocTypesEmpty:
        'No types yet. With no active required types, the documentation step is considered complete.',
      onboardingContractsEmpty: 'No templates yet.',
      onboardingNewDocType: 'New document type',
      onboardingAddDocType: 'Add type',
      onboardingDocTypeInvalid: 'Enter name and slug.',
      onboardingDocTypeCreated: 'Type created.',
      onboardingDocTypeCreateError: 'Could not create the type.',
      onboardingDocTypeSaved: 'Type updated.',
      onboardingDocTypeSaveError: 'Could not update the type.',
      onboardingDocTypeDeleted: 'Type removed.',
      onboardingDocTypeDeleteError: 'Could not remove the type.',
      onboardingNewContract: 'New contract template',
      onboardingAddContract: 'Add template',
      onboardingRefUrlPlaceholder: 'Reference template URL (optional)',
      onboardingContractRefUpload: 'Upload file',
      onboardingContractRefUploading: 'Uploading…',
      onboardingContractRefUploadError: 'Could not upload the file.',
      onboardingContractRefOpen: 'Open',
      onboardingContractRefPending: 'File staged — it will be linked when you add the template.',
      onboardingContractInvalid: 'Enter the template name.',
      onboardingContractCreated: 'Template created.',
      onboardingContractCreateError: 'Could not create the template.',
      onboardingContractSaved: 'Template updated.',
      onboardingContractSaveError: 'Could not update the template.',
      onboardingContractDeleted: 'Template removed.',
      onboardingContractDeleteError: 'Could not remove the template.',
      confirmDeleteOnboardingDocType: 'Delete document type?',
      confirmDeleteOnboardingDocTypeHint: 'Only allowed when no sale fulfillments reference this type.',
      confirmDeleteOnboardingContract: 'Delete contract template?',
      confirmDeleteOnboardingContractHint: 'Only allowed when no sale fulfillments reference this template.',
    },
    paymentForms: {
      isFinancing: 'Financing',
      isCashPayment: 'Cash / pay in full',
      kindHint: 'Classify this method for reporting and rules. Only one of the two can be enabled.',
      exclusiveConflict: 'Cannot mark both financing and cash at the same time.',
      badgeFinancing: 'Financing',
      badgeCash: 'Cash',
    },
    dealership: {
      pageTitle: 'Dealership Settings',
      pageSubtitle: 'Branches, per-branch fiscal data, and vehicle categories',
      vehicleTypes: {
        title: 'Vehicle Types',
        sectionTitle: 'Accepted Vehicle Types',
        sectionDescription: 'Select the vehicle types your dealership works with. If none are selected, all types are shown.',
        saveButton: 'Save Vehicle Types',
        saveSuccess: 'Saved successfully',
      },
      branch: {
        title: 'Branches',
        sectionTitle: 'Branches',
        newButton: 'New Branch',
        emptyTitle: 'No branches registered',
        emptyDescription: 'Click "New Branch" to add the first branch.',
        primaryBadge: 'Main',
        listVehicleCategories: 'Categories',
        categoryLabels: {
          A: 'Motorcycles',
          B: 'Passenger cars',
          C: 'Trucks',
          D: 'Buses',
        },
        form: {
          newTitle: 'New Branch',
          editTitle: 'Edit Branch',
          createButton: 'Create Branch',
          saveEditButton: 'Save Changes',
          saveError: 'Failed to save branch',
          sectionBranch: 'Identification',
          sectionContact: 'Contact',
          sectionAddress: 'Address',
          sectionFiscal: 'Fiscal (NF-e / export)',
          fiscalHint:
            'State registration, tax regime, and default NCM/CFOP for this branch. The sale vehicle must be linked to this branch to use these values as issuer details.',
          phoneHint: 'Optional. Area code + local number.',
          categoriesSection: 'Vehicle categories for this branch',
          categoriesHint: 'Choose which vehicle types can be registered at this branch. At least one category is required.',
          categoriesRequired: 'Select at least one vehicle category.',
          invalidEmail: 'Please enter a valid email.',
          invalidPhone: 'Enter a valid phone number with area code (10 or 11 digits after the area code).',
          zipCodeLookupError: 'Could not retrieve address from ZIP code.',
          zipCodeIncomplete: 'Enter an 8-digit ZIP code before searching.',
          zipSearchButton: 'Look up ZIP',
          zipSearchHint: 'Type the ZIP code and click Look up, or press Enter in the field.',
          searchingZipCode: 'Searching address by ZIP code...',
          requiredFieldError: 'Required field is missing: {{field}}',
          fields: {
            name: 'Branch name *',
            phone: 'Phone',
            email: 'Email',
            zipCode: 'ZIP code *',
            street: 'Street *',
            number: 'Number *',
            complement: 'Complement',
            neighborhood: 'Neighborhood *',
            city: 'City *',
            state: 'State *',
            stateRegistration: 'State registration (IE)',
            taxRegime: 'Tax regime',
            fiscalDefaultNcm: 'Default NCM',
            fiscalDefaultCfop: 'Default CFOP',
          },
          placeholders: {
            name: 'Ex: Sao Paulo HQ',
            email: 'branch@company.com',
            street: 'Street name…',
            number: 'No.',
            complement: 'Suite, floor…',
            neighborhood: 'Neighborhood',
            city: 'City',
          },
        },
      },
      registration: {
        title: 'Company registration',
        subtitle: 'Fill in your company details to create the administrator account',
        stepTitles: {
          company: 'Company details',
          user: 'Administrator user',
          payment: 'Plan confirmation',
        },
        stepDescriptions: {
          company: 'Enter the CNPJ and company registration data',
          user: 'Create the user responsible for access',
          payment: 'Review the information before finishing',
        },
        company: {
          document: 'Company document',
          cpf: 'CPF',
          cnpj: 'CNPJ',
          cnpjPlaceholder: '00.000.000/0000-00',
          cnpjHint: 'Use the CNPJ of the company being registered.',
          legalName: 'Legal name',
          legalNamePlaceholder: 'Company legal name',
          tradeName: 'Trade name',
          tradeNamePlaceholder: 'Company trade name',
          cpfName: 'Responsible person name',
          cpfNamePlaceholder: 'Full name',
          email: 'Company email',
          emailPlaceholder: 'contact@company.com',
          phone: 'Company phone',
          phonePlaceholder: '(11) 99999-9999',
          address: 'Company address',
        },
        user: {
          sectionTitle: 'Administrator access',
          sectionSubtitle: 'Set the details for the person responsible for the company account.',
          name: 'Responsible person name',
          namePlaceholder: 'Full name',
          email: 'Responsible person email',
          emailPlaceholder: 'admin@company.com',
          password: 'Administrator password',
          passwordPlaceholder: 'Minimum 6 characters',
          confirmPassword: 'Confirm password',
          confirmPasswordPlaceholder: 'Confirm your password',
        },
        payment: {
          selectedPlan: 'Selected plan',
          vehiclesUnlimited: 'Unlimited vehicles',
          vehicles: '{{count}} vehicles',
          free: 'Free',
          perMonth: '/month',
          companySummary: 'Company summary',
          termsTitle: 'Terms and conditions',
          termsPrefix: 'By continuing, you agree to our',
          termsLink: 'Terms of Use',
          and: 'and',
          privacyLink: 'Privacy Policy',
        },
        actions: {
          back: 'Back',
          continue: 'Continue',
          validating: 'Validating...',
          finish: 'Finish registration',
        },
        login: {
          prompt: 'Already have an account?',
          link: 'Log in',
        },
        success: {
          noTokenMessage: 'Company registered successfully! Log in to continue.',
          verificationRequired: 'Dealership registered successfully! Check your email to continue.',
        },
        validation: {
          cpfRequired: 'CPF is required',
          cpfLength: 'Enter 11 digits for CPF',
          cpfValidating: 'Validating CPF...',
          cpfInvalid: 'Invalid CPF',
          cpfValidationError: 'Error validating CPF. Please try again.',
          cnpjRequired: 'CNPJ is required',
          cnpjLength: 'Enter 14 digits for CNPJ',
          cnpjValidating: 'Validating CNPJ...',
          cnpjInvalid: 'Invalid CNPJ',
          cnpjValidationError: 'Error validating CNPJ. Please try again.',
          tooManyRequests: 'Too many attempts. Please wait a moment and try again.',
          legalNameRequired: 'Legal name is required',
          companyEmailRequired: 'Company email is required',
          invalidEmail: 'Invalid email',
          phoneRequired: 'Phone is required',
          invalidPhone: 'Invalid phone',
          addressRequired: 'Complete the full address (ZIP code, street, number, neighborhood, city, and state).',
          userNameRequired: 'Name is required',
          userEmailRequired: 'Email is required',
          passwordRequired: 'Password is required',
          passwordLength: 'Password must have at least 6 characters',
          confirmPasswordRequired: 'Password confirmation is required',
          passwordMismatch: 'Passwords do not match',
          submitError: 'Error registering company. Please try again.',
          connectionError: 'Connection error. Check your internet and try again.',
          cpfNameRequired: 'Name is required',
          fieldRequired: 'Required',
        },
        hero: {
          eyebrow: 'Premium signup',
          title: 'A registration experience that feels like a serious product',
          subtitle:
            'A guided 3-step flow with a fixed summary column and a much stronger visual hierarchy for dealership teams.',
          stats: {
            validationTitle: 'Validation',
            validationValue: 'In real time',
            validationDescription: 'CNPJ, ZIP code, and critical fields with instant feedback.',
            flowTitle: 'Flow',
            flowValue: '3 steps',
            flowDescription: 'Company, user, and plan confirmation without friction.',
            securityTitle: 'Confidence',
            securityValue: 'Account ready',
            securityDescription: 'Clear review before the final submission.',
          },
          bullets: {
            premiumVisualTitle: 'Premium look',
            premiumVisualDescription: 'More hierarchy, contrast, and brand presence.',
            guidedFlowTitle: 'Guided flow',
            guidedFlowDescription: 'The next step is always obvious to the user.',
            trustTitle: 'More trust',
            trustDescription: 'Summary, progress, and review reduce drop-off.',
          },
        },
        sidebar: {
          eyebrow: 'Signup summary',
          quickSummary: 'Quick summary',
          title: 'Everything you need to finish',
          planActive: 'Active plan',
          progressLabel: 'Registration progress',
          progressValue: '{{current}} of {{total}} steps',
          planSummary: 'Selected plan',
          planUsers: 'Included users',
          planVehicles: 'Included vehicles',
          usersCount: '{{count}} users',
          usersUnlimited: 'Unlimited users',
          stepPrefix: 'Step {{count}}',
          benefits: {
            title: 'Onboarding highlights',
            fastSetupTitle: 'Faster start',
            fastSetupDescription: 'The visual structure guides the signup with less friction.',
            protectedAccessTitle: 'Protected access',
            protectedAccessDescription: 'Credentials and final review are presented clearly.',
            accountReadyTitle: 'Ready to operate',
            accountReadyDescription: 'When you finish, the initial structure is already set.',
          },
        },
        form: {
          eyebrow: 'Dealership registration',
        },
        common: {
          notProvided: 'Not provided',
        },
      },
    },
  },

  whatsapp: {
    title: 'WhatsApp Business',
    subtitle: 'Configure WhatsApp Business API integration to send and receive messages',
    newTitle: 'New Configuration',
    editTitle: 'Edit Configuration',
    confirmDelete: 'Are you sure you want to remove the WhatsApp configuration?',
    noMessages: 'No messages yet',
    typeMessage: 'Type a message...',
    downloadMedia: 'Download file',
    emojiPicker: 'Emoji',
    suggestionTitle: 'Suggestions to apply on lead',
    suggestionApplying: 'Applying...',
    suggestionApplied: 'Interest applied on lead',
    suggestionDismiss: 'Dismiss suggestion and do not show again',
    suggestionPurchaseIntent: 'Apply purchase intent',
    suggestionUsageType: 'Apply usage type',
    suggestionVehicleMoment: 'Apply vehicle moment',
    suggestionFinancing: 'Apply financing interest',
    suggestionTradeIn: 'Apply trade-in interest',
    suggestionNotePurchaseIntent: 'Purchase intent detected in conversation.',
    suggestionNoteUsageType: 'Usage type detected in conversation.',
    suggestionNoteVehicleMoment: 'Vehicle moment detected in conversation.',
    suggestionNoteTradeIn: 'Trade-in interest detected in conversation.',
    suggestionNoteFinancing: 'Financing interest detected in conversation.',
    suggestionKeywords: {
      wantsFinancing: 'finance|financing|financial|installments|loan|down payment',
      hasTradeIn: 'trade in|trade-in|exchange|swap|my car as down payment',
      purchaseIntentUrgent: 'urgent|asap|today|this week|close now',
      purchaseIntentResearching: 'researching|looking around|checking options',
      purchaseIntentComparing: 'comparing|compare|other options',
      usageTypeUber: 'uber|rideshare|99 app',
      usageTypeCommercial: 'commercial|business|fleet|work usage',
      usageTypeFamily: 'family|kids|children',
      usageTypePersonal: 'personal|private use',
      vehicleMomentFirstCar: 'first car|my first vehicle',
      vehicleMomentUpgrade: 'upgrade|better car|move up',
      vehicleMomentReplacement: 'replace|replacement|change current car',
    },
    retryAction: 'Retry message',
    retryLabel: 'Retry',
    retrySent: 'Message resent successfully',
    retryMediaUnavailable: 'Could not retry: media unavailable',
    status: { active: 'Active', inactive: 'Inactive' },
    fields: {
      phoneNumberId: 'Phone Number ID',
      businessAccountId: 'Business Account ID',
      accessToken: 'Access Token',
      webhookVerifyToken: 'Webhook Verify Token',
      isActive: 'Active',
      autoReply: 'Auto-reply',
      autoCreateLead: 'Auto-create lead',
      mediaPlaceholder: 'Select...',
    },
    placeholders: {
      phoneNumberId: 'Phone number ID',
      businessAccountId: 'Business account ID',
      accessToken: 'Long-lived access token',
      webhookVerifyToken: 'Webhook verification token',
    },
    actions: { test: 'Test Connection', syncTemplates: 'Sync Templates', connectWithMeta: 'Connect with Meta' },
    messageTypes: { text: 'Text', image: 'Image', video: 'Video', document: 'Document', template: 'Template' },
    templates: {
      title: 'Message Templates',
      subtitle: 'Manage approved WhatsApp Business templates',
      empty: 'No templates configured',
      emptyHint: 'Sync templates from WhatsApp Business or create new ones in Meta Business Manager',
      used: 'Used',
      times: 'times',
      helpTitle: 'How to use templates',
      help1: 'Templates are pre-approved messages by WhatsApp to start conversations.',
      help2: 'Create and approve templates in Meta Business Manager before using them here.',
      help3: 'Use the "Sync Templates" button to import approved templates.',
      sync: 'Sync Templates',
      syncHint: 'Click "Sync Templates" to load templates from Meta',
      usageCount: 'Usage',
    },
    templateStatus: { approved: 'Approved', pending: 'Pending', rejected: 'Rejected', inactive: 'Inactive' },
    templateCategory: { marketing: 'Marketing', utility: 'Utility', authentication: 'Authentication' },
    success: {
      created: 'WhatsApp configuration created successfully!',
      updated: 'Configuration updated successfully!',
      deleted: 'Configuration removed successfully!',
      tested: 'Connection tested successfully!',
      messageSent: 'Message sent successfully!',
      templatesSynced: 'Templates synced successfully!',
      connected: 'WhatsApp connected successfully!',
      disconnected: 'WhatsApp disconnected successfully',
      oauthConnected: 'Successfully connected via Meta!',
    },
    errors: {
      load: 'Could not load configuration.',
      required: 'All fields are required.',
      save: 'Could not save configuration.',
      delete: 'Could not remove configuration.',
      test: 'Error testing connection.',
      testFailed: 'Connection test failed',
      loadMessages: 'Could not load messages.',
      sendMessage: 'Could not send message.',
      loadTemplates: 'Could not load templates.',
      syncTemplates: 'Could not sync templates.',
      disconnect: 'Error disconnecting WhatsApp',
      oauthFailed: 'Error connecting with Meta. Please try again.',
      reconnect: 'Error reconnecting',
    },
    errorTypes: {
      META_AUTHENTICATION: 'Authentication error',
      META_RATE_LIMIT: 'Rate limit exceeded',
      META_BUSINESS_RULE: 'Business rule',
      META_VALIDATION: 'Validation',
      META_COUNTRY_RESTRICTION: 'Country restriction',
      META_NUMBER_NOT_ALLOWED: 'Number not allowed',
      META_TEMPLATE_NOT_APPROVED: 'Template not approved',
      SYSTEM_ERROR: 'System error',
      INVALID_CONFIG: 'Invalid configuration',
      WHATSAPP_CHANNEL_SESSION_EXPIRED: 'Outside the 24-hour window; use an approved template',
      WHATSAPP_CONVERSATION_FINALIZED: 'Conversation ended; reopen or wait for the customer',
      META_PHONE_NUMBER_UNAVAILABLE:
        'Phone Number ID or token is not valid for Meta — update WhatsApp settings or reconnect',
    },
    session: {
      templateOnlyBanner:
        'Only approved templates can be sent. The 24-hour session after the customer last message has expired.',
      closedBanner:
        'Conversation ended. Reopen to resume response metrics or send an approved template.',
      finalize: 'End conversation',
      reopen: 'Reopen conversation',
      finalizedToast: 'Conversation ended.',
      reopenedToast: 'Conversation reopened.',
    },
    help: {
      step1Title: '1. Create App in Meta Business',
      step1: 'Go to developers.facebook.com and create a Business app. Activate the WhatsApp Business API.',
      step2Title: '2. Get Credentials',
      step2: 'In the app panel, go to "WhatsApp > API Setup" to get Phone Number ID and permanent Access Token.',
      step3Title: '3. Configure Webhook',
      step3: 'Configure the WhatsApp webhook to receive messages. Use the URL and token below.',
      webhookTitle: 'Webhook URL',
      webhookUrl: 'URL',
    },
    inbox: {
      title: 'WhatsApp Inbox',
      subtitle: 'Manage conversations and reply to messages from your leads',
      conversations: 'Conversations',
      searchPlaceholder: 'Search by name or number...',
      empty: 'No conversations yet',
      noResults: 'No results found',
      noMessages: 'No messages',
      selectConversation: 'Select a conversation',
      selectConversationHint: 'Choose a conversation from the list on the left to start',
      now: 'now',
      filters: {
        all: 'All',
        unread: 'Unread',
        today: 'Today',
        mine: 'Mine',
      },
      rightPanel: {
        empty: 'Select a conversation to view contact and inventory.',
        leadSection: 'Contact',
        noLead: 'No lead linked to this conversation.',
        vehicleSearch: 'Vehicle search',
        searchVehicles: 'Search',
        vehiclesFound: '{{count}} vehicle(s) found',
        expandContactSection: 'Expand contact',
        collapseContactSection: 'Collapse contact',
        expandFiltersSection: 'Expand filters',
        collapseFiltersSection: 'Collapse filters',
        noVehicles: 'No vehicles match the filters.',
        sendVehicleInfo: 'Send summary on WhatsApp',
        sendPhotos: 'Send photos',
        sendDocuments: 'Send documents',
        confirmSend: 'Send',
        confirmPhotosTitle: 'Send photos via WhatsApp?',
        confirmPhotosBody:
          'Up to 10 photos will be sent in sequence. URLs must be reachable by Meta.',
        confirmDocsTitle: 'Send documents via WhatsApp?',
        confirmDocsBody: 'Files will be sent one by one as documents.',
        success: {
          textSent: 'Vehicle summary sent.',
          photosSent: '{{count}} photo(s) sent.',
          photosPartial: '{{ok}} of {{total}} photo(s) sent.',
          docsSent: '{{count}} document(s) sent.',
          docsPartial: '{{ok}} of {{total}} document(s) sent.',
        },
        errors: {
          loadLead: 'Could not load lead.',
          loadVehicles: 'Could not load vehicles.',
          sendFailed: 'Failed to send via WhatsApp.',
          noPhotos: 'This vehicle has no photos.',
          noDocuments: 'This vehicle has no documents.',
        },
      },
      errors: { loadConversations: 'Could not load conversations.' },
    },
    info: {
      dialogTitle: 'WhatsApp Integration Details',
      connected: 'Connected',
      disconnected: 'Disconnected',
      activeStatus: 'WhatsApp is active and working',
      inactiveStatus: 'WhatsApp is inactive',
      noConfig: 'No configuration found',
      noConfigHint: 'Click "Connect" on the Marketplace page to configure WhatsApp.',
      lastSync: 'Last Sync',
      createdAt: 'Created at',
      never: 'Never',
      configurations: 'Settings',
      autoReplyEnabled: 'Auto-reply enabled',
      autoCreateLeadEnabled: 'Auto-create leads',
      lastError: 'Last error',
      webhookUrl: 'Webhook URL',
      webhookHint: 'Configure this URL in the Meta Dashboard:',
      reconnect: 'Reconnect',
      reconnecting: 'Reconnecting...',
      disconnect: 'Disconnect',
      disconnecting: 'Disconnecting...',
      close: 'Close',
      confirmDisconnect: 'Are you sure you want to disconnect WhatsApp?',
      confirmDisconnectWarning: 'All configuration data will be removed and you will need to reconnect again.',
      confirmDisconnectButton: 'Yes, Disconnect',
      processingConnection: 'Processing connection...',
    },
    errorHelp: {
      checkMeta: 'Check the settings in Meta Business Manager',
      metaIssue: 'This is a configuration issue in Meta Business Manager, not in the system.',
      openMetaManager: 'Open Meta Business Manager',
    },
  },

  marketplace: {
    title: 'Marketplace',
    subtitle: 'Connect your integrations to attract more leads',
    comingSoon: 'Coming soon',
    comingSoonHint:
      'This integration is not available in this release yet. Use Mercado Livre and WhatsApp for now.',
    connected: 'Connected',
    notConnected: 'Not connected',
    howToConnect: 'How to connect',
    connect: 'Connect',
    connecting: 'Connecting...',
    disconnect: 'Disconnect',
    disconnecting: 'Disconnecting...',
    reconnect: 'Reconnect',
    reconnecting: 'Reconnecting...',
    viewDetails: 'View Details',
    templates: 'Templates',
    integrations: {
      whatsapp: {
        name: 'WhatsApp Business',
        description: 'Connect WhatsApp Business to receive and send messages, auto-create leads, and manage templates.',
        helpText: 'Requires a Meta-approved WhatsApp Business API account.',
      },
      meta: {
        name: 'Meta',
        description: 'Connect your Instagram and Facebook Business to receive leads automatically.',
        helpText: 'Requires a Facebook Business account and a professional Instagram page.',
      },
      mercadolivre: {
        name: 'Mercado Livre',
        description: 'Publish your vehicles automatically and receive buyer messages.',
        helpText: 'Requires a Mercado Livre seller account and an approved app.',
        title: 'Mercado Livre',
        oauthConnected: 'Mercado Livre account linked successfully.',
        notConfigured: 'Mercado Livre is not configured yet.',
        active: 'Integration is active and working.',
        accountInfo: 'Account details',
        userId: 'User ID',
        connectedAt: 'Connected on',
        lastSync: 'Last sync',
        lastError: 'Last error',
        disconnect: {
          title: 'Disconnect Mercado Livre',
          warning:
            'After disconnecting, you cannot publish or sync listings until you link the account again.',
        },
        errors: {
          load: 'Could not load Mercado Livre status.',
          reconnect: 'Could not start reconnection.',
          disconnect: 'Could not disconnect Mercado Livre.',
          notFound: 'No Mercado Livre integration was found.',
        },
      },
      olx: {
        name: 'OLX',
        description: 'Promote your vehicles on Brazil largest classifieds platform.',
        helpText: 'Requires an OLX professional account and listing approval.',
      },
    },

    success: {
      connected: 'Integration connected successfully!',
      disconnected: 'Integration disconnected successfully!',
    },

    errors: {
      connect: 'Error connecting',
      unknown: 'Unknown error',
    },

    publications: {
      title: 'Publications',
      subtitle: 'Manage vehicle publications to marketplaces',
      selectMarketplace: 'Select marketplace',
      searchVehicles: 'Search vehicles...',
      publish: 'Publish',
      publishing: 'Publishing...',
      selectAtLeastOne: 'Select at least one vehicle',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      availableVehicles: 'Available Vehicles',
      vehicle: 'Vehicle',
      year: 'Year',
      price: 'Price',
      status: 'Status',
      publishedOn: 'Published On',
      actions: 'Actions',
      history: 'History',
      notPublished: 'Not published',
      success: '{{queued}} vehicles sent for publication. {{failed}} failed.',
      error: 'Error publishing vehicles',
      autoPublish: {
        title: 'Auto Publication',
        enabled: 'Enabled',
        disabled: 'Disabled',
        enable: 'Enable auto publication',
        disable: 'Disable auto publication',
        description: 'Vehicles will be automatically published at marketplace processing times',
        scheduleInfo: 'Processing Schedule',
        scheduleDescription: 'Marketplaces process publications at specific times for better performance',
        error: 'Error updating auto publication',
      },
    },

    history: {
      title: 'Publication History',
      subtitle: 'Track all publications',
      filterByMarketplace: 'Filter by Marketplace',
      filterByStatus: 'Filter by Status',
      allMarketplaces: 'All Marketplaces',
      allStatuses: 'All Statuses',
      vehicle: 'Vehicle',
      marketplace: 'Marketplace',
      status: 'Status',
      publishedAt: 'Published at',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      actions: 'Actions',
      viewAd: 'View Ad',
      noPublications: 'No publications found',
      error: 'Error loading history',
      page: 'Page',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      statusTypes: {
        PENDING: 'Pending',
        PUBLISHED: 'Published',
        FAILED: 'Failed',
        UPDATING: 'Updating',
        PAUSED: 'Paused',
        REMOVED: 'Removed',
      },
    },

    logs: {
      title: 'History',
      loadingHistory: 'Loading history...',
      noPublications: 'No publications found for this vehicle',
      viewAd: 'View Ad',
      eventHistory: 'Event History',
      noEvents: 'No events recorded',
      attempt: 'Attempt',
      hideDetails: 'Hide details',
      showDetails: 'Show details',
      errorDetails: 'Error Details:',
      apiResponse: 'API Response:',
      error: 'Error loading history',
      actions: {
        CREATED: 'Created',
        QUEUED: 'Queued',
        PROCESSING: 'Processing',
        PUBLISHED: 'Published',
        UPDATED: 'Updated',
        FAILED: 'Failed',
        RETRYING: 'Retrying',
        REMOVED: 'Removed',
        ERROR: 'Error',
      },
    },
  },

  // Conversations
  conversations: {
    title: 'Conversations',
    searchPlaceholder: 'Search conversations...',
    noConversations: 'No conversations found',
    selectConversation: 'Select a conversation',
    selectConversationHint: 'Choose a conversation from the list to start',
    selectToViewContext: 'Select a conversation to view context',
    back: 'Back',
    lastActivity: 'Last activity',
    messagePlaceholder: 'Type your message...',
    messageSent: 'Message sent successfully',
    attachment: 'Attach file',
    emoji: 'Add emoji',
    quickTemplate: 'Quick template',
    noteAdded: 'Note added successfully',
    tagAdded: 'Tag added successfully',

    filters: {
      all: 'All',
      unread: 'Unread',
      mine: 'Mine',
      hot: 'Hot',
      today: 'Today',
      tags: 'Tags',
    },

    metrics: {
      title: 'Metrics',
      subtitle: 'Last 30 days',
      expand: 'Expand metrics',
      collapse: 'Collapse metrics',
      avgResponseTime: 'Avg response time',
      responseRate: 'Response rate',
      conversionRate: 'Conversion rate',
      noData: '—',
      lessThanMinute: '< 1 min',
      minutes: '{{count}} min',
      hours: '{{count}} h',
      hoursMinutes: '{{hours}} h {{minutes}} min',
    },

    actions: {
      newConversation: 'New conversation',
    },

    quickActions: {
      title: 'Quick actions',
      createProposal: 'Create proposal',
      scheduleTestDrive: 'Schedule test drive',
      linkVehicle: 'Link vehicle',
      editLead: 'Edit lead',
      addSelectedVehicleInterest: 'Add selected vehicle to interests',
    },

    success: {
      newConversationCreated: 'Conversation ready. You can reply below.',
    },

    leadData: {
      title: 'Lead Data',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      source: 'Source',
      notes: 'Notes',
      condition: 'Condition',
      fuelType: 'Fuel type',
      transmission: 'Transmission',
      minPrice: 'Min price',
      maxPrice: 'Max price',
      minYear: 'Min year',
      maxYear: 'Max year',
      editLead: 'Edit lead',
      cancelEdit: 'Cancel edit',
      save: 'Save lead data',
      saving: 'Saving...',
      updated: 'Lead data updated',
      updateError: 'Error updating lead data',
      historyTitle: 'History',
      historyEmpty: 'No activity recorded',
    },

    leadScore: {
      title: 'Lead Score',
      classification: 'Classification',
      hot: 'Hot',
      warm: 'Warm',
      cold: 'Cold',
    },

    vehicleInterest: {
      title: 'Interest',
      price: 'Price',
      viewStock: 'View Stock',
    },

    activity: {
      title: 'Activity',
      noActivity: 'No activity recorded',
    },

    notes: {
      title: 'Notes',
      placeholder: 'Type your note...',
      add: 'Add',
      cancel: 'Cancel',
      noNotes: 'No notes added',
    },

    tags: {
      title: 'Tags',
      noTags: 'No tags added',
    },
    errors: {
      configure: 'Configure WhatsApp',
      loadError: 'Error loading conversations',
      loadLeadError: 'Error loading lead data',
      loadTemplatesError: 'Error loading templates',
      notConfigured: 'WhatsApp not configured',
      notConfiguredDesc: 'Configure WhatsApp before using conversations',
      sendError: 'Error sending message',
    },
    newConversation: {
      conversationStarted: 'Conversation started! Send the first message using a template.',
      createLead: 'Create Lead',
      createLeadError: 'Error creating lead',
      createNewLead: 'Create New Lead',
      email: 'Email',
      emailPlaceholder: 'Enter the email',
      fillAllParameters: 'Fill in all parameters',
      initialMessage: 'Initial message (optional)',
      initialMessagePlaceholder: 'Type an initial message...',
      leadCreated: 'Lead created successfully',
      leadNoPhone: 'This lead has no phone number on file',
      name: 'Name',
      namePlaceholder: 'Enter the name',
      nameRequired: 'Name is required',
      new: 'New Conversation',
      noLeadsFound: 'No leads found',
      orCreateNew: 'Or create a new lead',
      parameter: 'Parameter',
      parameters: 'Parameters',
      phone: 'Phone',
      phonePlaceholder: 'Enter the phone number',
      phoneRequired: 'Phone number is required',
      preview: 'Preview',
      searchLead: 'Search lead',
      searchPlaceholder: "Type the lead's name...",
      selectLeadFirst: 'Select a lead first',
      selectTemplate: 'Select Template',
      selectTemplateFirst: 'Select a template first',
      selectTemplatePlaceholder: 'Choose a template...',
      sendAndStart: 'Send and Start',
      source: 'Source',
      startConversation: 'Start Conversation',
      startError: 'Error starting conversation',
      templateNote: 'The first message must be a template approved by Meta. After opening the conversation, click "Select Template" to send.',
      templateSent: 'Template sent successfully',
      title: 'New Conversation',
    },
    quickTemplates: {
      greeting: 'Greeting',
      proposal: 'Proposal',
      scheduling: 'Scheduling',
      title: 'Quick Templates',
    },
    templates: {
      availableTemplates: 'Available Templates',
      categories: {
        AUTHENTICATION: 'Authentication',
        MARKETING: 'Marketing',
        UTILITY: 'Utility',
      },
      category: 'Category',
      createNewTemplate: 'Create New Template on Meta',
      errors: {
        invalidParameters: 'Invalid parameter',
        invalidParametersHint: "Check that you've filled in all required fields",
        loadError: 'Error loading templates',
        notFound: 'Template not found',
        notFoundHint: 'Sync templates in settings',
        sendError: 'Error sending template',
        syncError: 'Error syncing templates',
      },
      language: 'Language',
      noTemplates: 'No templates available',
      parameters: 'Parameters',
      preview: 'Preview',
      searchPlaceholder: 'Search template...',
      selectTemplate: 'Select Template',
      status: {
        APPROVED: 'Approved',
        PENDING: 'Pending',
        REJECTED: 'Rejected',
      },
      templateSent: 'Template sent successfully',
      useTemplate: 'Use Template',
    },
    window24h: {
      active: '24h window active',
      expired: '24h window expired',
      expiresIn: '24h window expires in',
      hours: 'h',
      minutes: 'm',
      mustSendTemplate: 'You must send a template first',
      needsTemplate: 'Send a template to reopen',
      newConversation: 'This is a new conversation',
      selectTemplateButton: 'Select Template',
    },
  },

  billing: {
    title: 'Subscription & billing',
    subtitle: 'Manage your plan, payments and subscription invoices',
    settingsCardTitle: 'Subscription & billing',
    settingsCardDescription: 'Current plan, upgrade, payment method and invoices',
    currentPlan: 'Current plan',
    currentPlanBadge: 'Current plan',
    plansTitle: 'Available plans',
    plansSubtitle: 'Compare and upgrade your plan',
    invoicesTitle: 'Payment history',
    invoicesSubtitle: 'Invoices from your subscription',
    noInvoices: 'No invoices yet.',
    invoiceDate: 'Date',
    invoiceAmount: 'Amount',
    invoiceStatus: 'Status',
    invoicePaidAt: 'Paid on',
    viewInvoice: 'View invoice',
    nextPayment: 'Next payment',
    lastPayment: 'Last payment',
    trialEnd: 'Trial ends',
    monthly: 'Monthly',
    yearly: 'Yearly',
    month: 'month',
    year: 'year',
    managePayment: 'Manage payment',
    completePayment: 'Complete payment',
    upgradePlan: 'Upgrade plan',
    cancelSubscription: 'Cancel subscription',
    cancelConfirm: 'Cancel subscription at the end of the current period?',
    cancelScheduled: 'Cancellation scheduled for period end.',
    cancelAtPeriodEnd: 'Cancels at period end',
    checkoutSuccess: 'Payment setup completed successfully.',
    checkoutCancelled: 'Checkout cancelled. No changes were made.',
    planChanged: 'Plan updated successfully.',
    noSubscriptionTitle: 'Subscription not found',
    noSubscriptionDescription: 'Contact support or choose a plan below to enable billing.',
    status: {
      incomplete: 'Payment pending',
      trialing: 'Trial',
      active: 'Active',
      past_due: 'Past due',
      canceled: 'Canceled',
      unpaid: 'Unpaid',
    },
    errors: {
      load: 'Failed to load subscription',
      portal: 'Could not open payment portal',
      changePlan: 'Failed to change plan',
      downgrade: 'Cannot downgrade: plan limits exceeded',
      cancel: 'Failed to cancel subscription',
      noSubscription: 'Subscription not configured',
      samePlan: 'This is already your current plan',
      ownerOnlyPortal: 'Only the owner can change the payment method in the portal.',
    },
  },

  ui: {
    languageSwitcher: {
      triggerLabel: 'Select language',
      triggerTitle: 'Open language selector',
      languages: {
        pt: 'Portuguese',
        en: 'English',
        es: 'Spanish',
      },
    },
  },

  notFound: {
    title: 'Page not found',
    message: "The page you're looking for doesn't exist or was moved.",
    backToDashboard: 'Back to dashboard',
    backToPlans: 'View plans',
  },

  publicPlans: {
      hero: {
        eyebrow: 'Plans',
        title: 'Choose the right plan for your dealership',
        subtitle:
          'Compare limits and features, choose monthly or yearly billing, and continue to registration.',
        trust1: 'No commitment',
        trust2: 'Instant activation',
        trust3: 'Support included',
        alreadyHaveAccount: 'Already have an account?',
        loginLink: 'Log in',
      },
      summary: {
        title: 'Selection summary',
        subtitle: 'Review the plan before moving forward.',
        priceLabelMonthly: '/month',
        priceLabelYearly: '/year',
        selectedPlan: 'Chosen plan',
        hint: 'Select a plan to continue',
      },
      actions: {
        continue: 'Continue',
        selectPlan: 'Select plan',
        selected: 'Selected',
      },
      comparison: {
        title: 'Feature comparison',
        resources: 'Features',
      },
      badges: {
        mostPopular: 'Most popular',
        saveUpTo: 'Save up to {{discount}}%',
      },
      features: {
        vehicles: 'Vehicles',
        users: 'Users',
        leads: 'Leads',
        support: 'Support',
        analytics: 'Analytics',
        customization: 'Customization',
        apiAccess: 'API access',
        multipleLocations: 'Multiple locations',
        unlimited: 'Unlimited',
        supportLevels: {
          none: 'None',
          email: 'Email',
          priority: 'Priority',
          dedicated: 'Dedicated',
        },
        analyticsLevels: {
          none: 'None',
          basic: 'Basic',
          advanced: 'Advanced',
          custom: 'Custom',
        },
      },
      billing: {
        monthly: 'Monthly',
        yearly: 'Yearly',
      },
      errors: {
        title: 'Failed to load plans',
        retry: 'Try again',
        loading: 'Loading plans…',
      },
    },

  publicOnboarding: {
      stepTitles: {
        config: 'Access and settings',
        summary: 'Final review',
      },
      stepDescriptions: {
        config: 'Create the administrator access and adjust the fiscal basics.',
        summary: 'Review the information before finishing.',
      },
    },

  auth: {
    login: {
      title: 'Sign in to your account',
      subtitle: 'ambcar · Dealership Management',
      email: 'E-mail',
      emailPlaceholder: 'your@email.com',
      password: 'Password',
      passwordPlaceholder: '••••••••',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot your password?',
      submit: 'Sign in',
      submitting: 'Signing in...',
      noAccount: "Don't have an account?",
      registerLink: 'Register your company',
      needHelp: 'Need help?',
      contactUs: 'Contact us',
      brand: {
        headline: 'The complete platform for dealership management',
        text1: 'Manage your inventory with intelligence and speed',
        text2: 'Qualified leads, faster closings',
        text3: 'Full visibility of your sales pipeline',
        text4: 'Automate processes, focus on results',
        text5: 'Faster commercial decisions, more efficient operations',
        feature1: 'Complete automotive inventory management',
        feature2: 'Real-time sales pipeline',
        feature3: 'WhatsApp and native CRM integration',
      },
      errors: {
        invalidCredentials: 'Invalid email or password',
        invalidCredentialsMsg: 'The credentials provided do not match our records.',
        invalidCredentialsSuggestion: 'Check that you typed your email and password correctly. Passwords are case-sensitive.',
        accessBlocked: 'Access blocked',
        accessBlockedMsg: 'Your account is blocked or you do not have permission to access this system.',
        accessBlockedSuggestion: 'Contact your dealership administrator or our support team for more information.',
        connectionError: 'Connection error',
        connectionErrorMsg: 'Could not establish a connection to the server.',
        connectionErrorSuggestion: 'Check your internet connection and try again. If the problem persists, our servers may be under maintenance.',
        timeout: 'Request timed out',
        timeoutMsg: 'The request took too long to process.',
        timeoutSuggestion: 'This may indicate an unstable connection. Wait a few seconds and try again.',
        serverError: 'Server temporarily unavailable',
        serverErrorMsg: 'Our servers are experiencing technical issues at the moment.',
        serverErrorSuggestion: 'Our team has been notified. Please try again in a few minutes.',
        tooManyAttempts: 'Too many login attempts',
        tooManyAttemptsMsg: 'You have exceeded the maximum number of login attempts.',
        tooManyAttemptsSuggestion: 'For security, wait 15 minutes before trying again.',
        generic: 'Login error',
        genericMsg: 'An unexpected error occurred while trying to log in.',
        genericSuggestion: 'Check your credentials and try again. If the problem persists, contact support.',
      },
      forgotPasswordInfo: 'Password recovery',
      forgotPasswordInfoMsg: 'Feature under development.',
      forgotPasswordInfoSuggestion: 'Contact your dealership administrator or our support team to reset your password.',
    },
    verifyEmail: {
      loginRequiredMessage: 'Your email needs to be verified before signing in. Check your inbox for the code.',
      title: 'Verify your email',
      subtitle: 'We sent a 6-digit code to',
      instruction: 'Enter the verification code',
      placeholder: '0',
      submit: 'Verify',
      submitting: 'Verifying...',
      resend: 'Resend code',
      resending: 'Resending...',
      resendIn: 'Resend in {{seconds}}s',
      expiresIn: 'Code expires in',
      expired: 'Code has expired',
      minutes: '{{minutes}} min',
      seconds: '{{seconds}}s',
      backToLogin: 'Back to login',
      didNotReceive: "Didn't receive the code?",
      checkSpam: 'Check your spam folder too',
      brand: {
        headline: 'Almost there!',
        text1: "We're verifying your identity to protect your account",
        text2: 'Email verification ensures the security of your data',
        text3: "In moments you'll have full access to the platform",
        feature1: 'Advanced account protection',
        feature2: 'Secure access to dealership data',
        feature3: 'Compliance with security best practices',
      },
      success: {
        title: 'Email verified!',
        message: 'Your email has been verified successfully. You can now access your account.',
      },
      errors: {
        invalidCode: 'Invalid code',
        invalidCodeMsg: 'The verification code entered is not valid.',
        invalidCodeSuggestion: 'Make sure you entered all 6 digits of the code received by email correctly.',
        expiredCode: 'Expired code',
        expiredCodeMsg: 'The verification code has expired.',
        expiredCodeSuggestion: 'Click "Resend code" to receive a new verification code.',
        notFound: 'Code not found',
        notFoundMsg: 'No verification code was found for this email.',
        notFoundSuggestion: 'Click "Resend code" to request a new code.',
        alreadyVerified: 'Email already verified',
        alreadyVerifiedMsg: 'This email has already been verified.',
        generic: 'Verification error',
        genericMsg: 'An error occurred while verifying the code.',
        genericSuggestion: 'Try again. If the problem persists, request a new code.',
        resendFailed: 'Resend failed',
        resendFailedMsg: 'Could not resend the verification code.',
        resendFailedSuggestion: 'Check your connection and try again in a few moments.',
      },
    },
  },
  postSalesPipeline: {
    subtitle: 'Post-sale deals with a guided flow through to preparation.',
    title: 'Sales pipeline',
    wizard: {
      backToList: 'Back to list',
      nextPhase: 'Go to next phase',
      persistStepError: "Could not update the sale's stage.",
      stepBack: 'Previous step',
    },
  },
}
